// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://api.fontshare.com/v2/css?f[]=cabinet-grotesk@800,500,700,900&f[]=satoshi@400,500,700&f[]=zodiak@401&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: "JetBrains Mono", ui-monospace, SFMono-Regular, monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

/* ── Semantic tokens ──────────────────────────────────────────────────
     These are the shadcn variables the whole app already runs on, retuned
     to the Daybreak palette. Extending this layer rather than adding a
     second one means every Button, Card, Input and Dialog in the product
     inherits the warmer ground for free, and there is still exactly one
     place to change a colour.

     The cool greys are gone. #f4f5f7 beside an indigo reads as a dashboard;
     the same layout on warm paper reads as print, and the canvas being
     slightly darker than the cards gives every card elevation for nothing —
     white-on-white had none. */

:root {
    --background: 40 47% 96%;      /* paper — the canvas */
    --foreground: 24 10% 10%;      /* warm near-black */
    --card: 0 0% 100%;             /* cards sit ABOVE the canvas, not level with it */
    --card-foreground: 24 10% 10%;
    --popover: 0 0% 100%;
    --popover-foreground: 24 10% 10%;
    --primary: 223 100% 33%;       /* Klein blue — the product's colour, unchanged */
    --primary-foreground: 0 0% 100%;
    --secondary: 40 30% 92%;
    --secondary-foreground: 24 10% 12%;
    --muted: 40 30% 92%;
    --muted-foreground: 30 6% 34%;
    --accent: 40 30% 92%;
    --accent-foreground: 24 10% 12%;
    --destructive: 346 84% 51%;
    --destructive-foreground: 0 0% 98%;
    --border: 38 31% 85%;          /* sand */
    --input: 38 31% 85%;
    --ring: 17 75% 49%;            /* dawn — the one focus colour, both grounds */
    --chart-1: 223 100% 33%;
    --chart-2: 160 84% 39%;
    --chart-3: 22 100% 68%;        /* dawn, so charts and the page share a light */
    --chart-4: 346 84% 51%;
    --chart-5: 30 6% 40%;
    --radius: 0.25rem;

    /* ── Type scale ────────────────────────────────────────────────────
       Fluid where it needs to be, fixed where fluid type would wobble.
       Named by role, not by size, so a heading can be retuned once. */
    --type-display: clamp(2.6rem, 7.2vw, 6rem);
    --type-h1: clamp(2.25rem, 4.6vw, 3.5rem);
    --type-h2: clamp(1.875rem, 3.2vw, 3rem);
    --type-h3: 1.5rem;
    --type-body-lg: 1.125rem;
    --type-body: 1rem;
    --type-small: 0.875rem;
    --type-label: 0.75rem;
    --tracking-display: -0.045em;
    --tracking-heading: -0.02em;
    --tracking-label: 0.2em;
    --leading-display: 0.92;
    --leading-body: 1.55;

    /* ── Shape, rhythm, layering ───────────────────────────────────── */
    --width-content: 80rem;
    --width-prose: 42rem;
    --shadow-card: 0 1px 2px rgba(28, 25, 23, 0.04);
    --shadow-lift: 0 12px 32px -14px rgba(28, 25, 23, 0.22);
    --shadow-stage: 0 44px 90px -44px rgba(0, 0, 0, 0.95);
    --z-nav: 60;
    --z-overlay: 80;
  }

/* ── The night theme ───────────────────────────────────────────────
     Put data-surface="night" on any dark section and the shadcn components
     inside it stop needing hand-written dark variants. This is why Stage
     sets it: a <Button> or <Input> dropped onto the hero should already be
     correct rather than needing a \`dark ?\` ternary at every call site.

     The status colours lighten here rather than keeping their light-ground
     values: #047857 green on an indigo ground is 2.4:1, which is how the
     hero's verification highlights ended up as the least readable thing on
     a page whose entire argument is verification.

     The same block serves html.dark — the app's Night mode (see
     lib/appearance.jsx and the appearance section at the end of this file). */

[data-surface="night"],
  .dark {
    --background: 226 54% 6%;
    --foreground: 0 0% 100%;
    --card: 226 40% 10%;
    --card-foreground: 0 0% 100%;
    --popover: 226 40% 10%;
    --popover-foreground: 0 0% 100%;
    --secondary: 226 30% 16%;
    --secondary-foreground: 0 0% 100%;
    --muted: 226 30% 16%;
    --muted-foreground: 226 12% 72%;
    --accent: 22 100% 81%;         /* dawn-300 */
    --accent-foreground: 226 54% 6%;
    --border: 226 20% 26%;
    --input: 226 20% 26%;
    --ring: 22 100% 81%;
    --destructive: 351 95% 71%;
    --destructive-foreground: 226 54% 6%;
  }

*{
  border-color: hsl(var(--border));
}

body{
  background-color: hsl(var(--background));
  color: hsl(var(--foreground));
}
.container{
  width: 100%;
}
@media (min-width: 640px){

  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){

  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){

  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){

  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1536px){

  .container{
    max-width: 1536px;
  }
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.visible{
  visibility: visible;
}
.invisible{
  visibility: hidden;
}
.collapse{
  visibility: collapse;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.inset-0{
  inset: 0px;
}
.-inset-x-2{
  left: -0.5rem;
  right: -0.5rem;
}
.inset-x-0{
  left: 0px;
  right: 0px;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.inset-y-1{
  top: 0.25rem;
  bottom: 0.25rem;
}
.inset-y-1\\.5{
  top: 0.375rem;
  bottom: 0.375rem;
}
.inset-y-2{
  top: 0.5rem;
  bottom: 0.5rem;
}
.-bottom-12{
  bottom: -3rem;
}
.-left-12{
  left: -3rem;
}
.-left-4{
  left: -1rem;
}
.-right-0\\.5{
  right: -0.125rem;
}
.-right-12{
  right: -3rem;
}
.-top-0\\.5{
  top: -0.125rem;
}
.-top-12{
  top: -3rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-20{
  bottom: 5rem;
}
.bottom-3\\.5{
  bottom: 0.875rem;
}
.bottom-36{
  bottom: 9rem;
}
.bottom-6{
  bottom: 1.5rem;
}
.bottom-\\[4\\%\\]{
  bottom: 4%;
}
.bottom-full{
  bottom: 100%;
}
.left-0{
  left: 0px;
}
.left-0\\.5{
  left: 0.125rem;
}
.left-1{
  left: 0.25rem;
}
.left-1\\/2{
  left: 50%;
}
.left-2{
  left: 0.5rem;
}
.left-2\\.5{
  left: 0.625rem;
}
.left-3{
  left: 0.75rem;
}
.left-4{
  left: 1rem;
}
.left-\\[-18\\%\\]{
  left: -18%;
}
.left-\\[26px\\]{
  left: 26px;
}
.left-\\[50\\%\\]{
  left: 50%;
}
.left-full{
  left: 100%;
}
.right-0{
  right: 0px;
}
.right-1{
  right: 0.25rem;
}
.right-1\\.5{
  right: 0.375rem;
}
.right-2{
  right: 0.5rem;
}
.right-3{
  right: 0.75rem;
}
.right-4{
  right: 1rem;
}
.right-5{
  right: 1.25rem;
}
.right-6{
  right: 1.5rem;
}
.right-\\[-6px\\]{
  right: -6px;
}
.right-full{
  right: 100%;
}
.top-0{
  top: 0px;
}
.top-0\\.5{
  top: 0.125rem;
}
.top-1{
  top: 0.25rem;
}
.top-1\\.5{
  top: 0.375rem;
}
.top-1\\/2{
  top: 50%;
}
.top-14{
  top: 3.5rem;
}
.top-2{
  top: 0.5rem;
}
.top-20{
  top: 5rem;
}
.top-3{
  top: 0.75rem;
}
.top-4{
  top: 1rem;
}
.top-7{
  top: 1.75rem;
}
.top-\\[11px\\]{
  top: 11px;
}
.top-\\[1px\\]{
  top: 1px;
}
.top-\\[50\\%\\]{
  top: 50%;
}
.top-\\[60\\%\\]{
  top: 60%;
}
.top-full{
  top: 100%;
}
.z-10{
  z-index: 10;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[100\\]{
  z-index: 100;
}
.z-\\[1\\]{
  z-index: 1;
}
.z-\\[60\\]{
  z-index: 60;
}
.col-span-1{
  grid-column: span 1 / span 1;
}
.col-span-2{
  grid-column: span 2 / span 2;
}
.col-span-3{
  grid-column: span 3 / span 3;
}
.col-span-4{
  grid-column: span 4 / span 4;
}
.col-span-full{
  grid-column: 1 / -1;
}
.m-0{
  margin: 0px;
}
.m-1{
  margin: 0.25rem;
}
.-mx-1{
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.-mx-6{
  margin-left: -1.5rem;
  margin-right: -1.5rem;
}
.mx-2{
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-3\\.5{
  margin-left: 0.875rem;
  margin-right: 0.875rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-6{
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.-mb-1{
  margin-bottom: -0.25rem;
}
.-ml-4{
  margin-left: -1rem;
}
.-mr-1{
  margin-right: -0.25rem;
}
.-mr-1\\.5{
  margin-right: -0.375rem;
}
.-mt-0\\.5{
  margin-top: -0.125rem;
}
.-mt-1{
  margin-top: -0.25rem;
}
.-mt-4{
  margin-top: -1rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-1\\.5{
  margin-bottom: 0.375rem;
}
.mb-10{
  margin-bottom: 2.5rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-3\\.5{
  margin-bottom: 0.875rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-1\\.5{
  margin-left: 0.375rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-9{
  margin-left: 2.25rem;
}
.ml-\\[26px\\]{
  margin-left: 26px;
}
.ml-auto{
  margin-left: auto;
}
.mr-0\\.5{
  margin-right: 0.125rem;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-1\\.5{
  margin-right: 0.375rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-3{
  margin-right: 0.75rem;
}
.mt-0{
  margin-top: 0px;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-12{
  margin-top: 3rem;
}
.mt-14{
  margin-top: 3.5rem;
}
.mt-16{
  margin-top: 4rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-2\\.5{
  margin-top: 0.625rem;
}
.mt-24{
  margin-top: 6rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-3\\.5{
  margin-top: 0.875rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-7{
  margin-top: 1.75rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-9{
  margin-top: 2.25rem;
}
.mt-auto{
  margin-top: auto;
}
.mt-px{
  margin-top: 1px;
}
.line-clamp-2{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-3{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.inline-grid{
  display: inline-grid;
}
.contents{
  display: contents;
}
.hidden{
  display: none;
}
.aspect-\\[7\\/5\\]{
  aspect-ratio: 7/5;
}
.aspect-\\[8\\.5\\/11\\]{
  aspect-ratio: 8.5/11;
}
.aspect-square{
  aspect-ratio: 1 / 1;
}
.aspect-video{
  aspect-ratio: 16 / 9;
}
.h-0\\.5{
  height: 0.125rem;
}
.h-1{
  height: 0.25rem;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-14{
  height: 3.5rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-20{
  height: 5rem;
}
.h-24{
  height: 6rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-32{
  height: 8rem;
}
.h-4{
  height: 1rem;
}
.h-40{
  height: 10rem;
}
.h-5{
  height: 1.25rem;
}
.h-56{
  height: 14rem;
}
.h-6{
  height: 1.5rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-9{
  height: 2.25rem;
}
.h-\\[17px\\]{
  height: 17px;
}
.h-\\[18px\\]{
  height: 18px;
}
.h-\\[1px\\]{
  height: 1px;
}
.h-\\[22px\\]{
  height: 22px;
}
.h-\\[28px\\]{
  height: 28px;
}
.h-\\[3px\\]{
  height: 3px;
}
.h-\\[56px\\]{
  height: 56px;
}
.h-\\[65vh\\]{
  height: 65vh;
}
.h-\\[72px\\]{
  height: 72px;
}
.h-\\[88vh\\]{
  height: 88vh;
}
.h-\\[var\\(--radix-navigation-menu-viewport-height\\)\\]{
  height: var(--radix-navigation-menu-viewport-height);
}
.h-\\[var\\(--radix-select-trigger-height\\)\\]{
  height: var(--radix-select-trigger-height);
}
.h-auto{
  height: auto;
}
.h-fit{
  height: fit-content;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.h-screen{
  height: 100vh;
}
.max-h-72{
  max-height: 18rem;
}
.max-h-96{
  max-height: 24rem;
}
.max-h-\\[--radix-context-menu-content-available-height\\]{
  max-height: var(--radix-context-menu-content-available-height);
}
.max-h-\\[--radix-select-content-available-height\\]{
  max-height: var(--radix-select-content-available-height);
}
.max-h-\\[28rem\\]{
  max-height: 28rem;
}
.max-h-\\[300px\\]{
  max-height: 300px;
}
.max-h-\\[70vh\\]{
  max-height: 70vh;
}
.max-h-\\[calc\\(100vh-6rem\\)\\]{
  max-height: calc(100vh - 6rem);
}
.max-h-\\[var\\(--radix-dropdown-menu-content-available-height\\)\\]{
  max-height: var(--radix-dropdown-menu-content-available-height);
}
.max-h-screen{
  max-height: 100vh;
}
.min-h-0{
  min-height: 0px;
}
.min-h-9{
  min-height: 2.25rem;
}
.min-h-\\[120px\\]{
  min-height: 120px;
}
.min-h-\\[20px\\]{
  min-height: 20px;
}
.min-h-\\[24rem\\]{
  min-height: 24rem;
}
.min-h-\\[4\\.5rem\\]{
  min-height: 4.5rem;
}
.min-h-\\[40px\\]{
  min-height: 40px;
}
.min-h-\\[44px\\]{
  min-height: 44px;
}
.min-h-\\[56px\\]{
  min-height: 56px;
}
.min-h-\\[60px\\]{
  min-height: 60px;
}
.min-h-\\[76px\\]{
  min-height: 76px;
}
.min-h-screen{
  min-height: 100vh;
}
.w-1\\.5{
  width: 0.375rem;
}
.w-10{
  width: 2.5rem;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\.5{
  width: 0.625rem;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-3\\/4{
  width: 75%;
}
.w-32{
  width: 8rem;
}
.w-36{
  width: 9rem;
}
.w-4{
  width: 1rem;
}
.w-40{
  width: 10rem;
}
.w-44{
  width: 11rem;
}
.w-5{
  width: 1.25rem;
}
.w-52{
  width: 13rem;
}
.w-56{
  width: 14rem;
}
.w-6{
  width: 1.5rem;
}
.w-60{
  width: 15rem;
}
.w-64{
  width: 16rem;
}
.w-7{
  width: 1.75rem;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-80{
  width: 20rem;
}
.w-9{
  width: 2.25rem;
}
.w-\\[100px\\]{
  width: 100px;
}
.w-\\[104\\%\\]{
  width: 104%;
}
.w-\\[17px\\]{
  width: 17px;
}
.w-\\[18px\\]{
  width: 18px;
}
.w-\\[1px\\]{
  width: 1px;
}
.w-\\[20rem\\]{
  width: 20rem;
}
.w-\\[22px\\]{
  width: 22px;
}
.w-\\[23\\.5rem\\]{
  width: 23.5rem;
}
.w-\\[3px\\]{
  width: 3px;
}
.w-\\[72px\\]{
  width: 72px;
}
.w-\\[82\\%\\]{
  width: 82%;
}
.w-\\[min\\(380px\\2c calc\\(100vw-2rem\\)\\)\\]{
  width: min(380px,calc(100vw - 2rem));
}
.w-full{
  width: 100%;
}
.w-max{
  width: max-content;
}
.w-px{
  width: 1px;
}
.min-w-0{
  min-width: 0px;
}
.min-w-10{
  min-width: 2.5rem;
}
.min-w-8{
  min-width: 2rem;
}
.min-w-9{
  min-width: 2.25rem;
}
.min-w-\\[120px\\]{
  min-width: 120px;
}
.min-w-\\[12rem\\]{
  min-width: 12rem;
}
.min-w-\\[140px\\]{
  min-width: 140px;
}
.min-w-\\[14rem\\]{
  min-width: 14rem;
}
.min-w-\\[160px\\]{
  min-width: 160px;
}
.min-w-\\[16px\\]{
  min-width: 16px;
}
.min-w-\\[180px\\]{
  min-width: 180px;
}
.min-w-\\[200px\\]{
  min-width: 200px;
}
.min-w-\\[220px\\]{
  min-width: 220px;
}
.min-w-\\[260px\\]{
  min-width: 260px;
}
.min-w-\\[3\\.25rem\\]{
  min-width: 3.25rem;
}
.min-w-\\[8\\.5rem\\]{
  min-width: 8.5rem;
}
.min-w-\\[8rem\\]{
  min-width: 8rem;
}
.min-w-\\[var\\(--radix-select-trigger-width\\)\\]{
  min-width: var(--radix-select-trigger-width);
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-5xl{
  max-width: 64rem;
}
.max-w-6xl{
  max-width: 72rem;
}
.max-w-7xl{
  max-width: 80rem;
}
.max-w-\\[13rem\\]{
  max-width: 13rem;
}
.max-w-\\[1400px\\]{
  max-width: 1400px;
}
.max-w-\\[16rem\\]{
  max-width: 16rem;
}
.max-w-\\[18rem\\]{
  max-width: 18rem;
}
.max-w-\\[620px\\]{
  max-width: 620px;
}
.max-w-full{
  max-width: 100%;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-max{
  max-width: max-content;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-none{
  max-width: none;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xl{
  max-width: 36rem;
}
.max-w-xs{
  max-width: 20rem;
}
.flex-1{
  flex: 1 1;
}
.shrink{
  flex-shrink: 1;
}
.shrink-0{
  flex-shrink: 0;
}
.grow{
  flex-grow: 1;
}
.grow-0{
  flex-grow: 0;
}
.basis-full{
  flex-basis: 100%;
}
.caption-bottom{
  caption-side: bottom;
}
.border-collapse{
  border-collapse: collapse;
}
.border-separate{
  border-collapse: separate;
}
.border-spacing-0{
  --tw-border-spacing-x: 0px;
  --tw-border-spacing-y: 0px;
  border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y);
}
.origin-\\[--radix-context-menu-content-transform-origin\\]{
  transform-origin: var(--radix-context-menu-content-transform-origin);
}
.origin-\\[--radix-dropdown-menu-content-transform-origin\\]{
  transform-origin: var(--radix-dropdown-menu-content-transform-origin);
}
.origin-\\[--radix-hover-card-content-transform-origin\\]{
  transform-origin: var(--radix-hover-card-content-transform-origin);
}
.origin-\\[--radix-menubar-content-transform-origin\\]{
  transform-origin: var(--radix-menubar-content-transform-origin);
}
.origin-\\[--radix-popover-content-transform-origin\\]{
  transform-origin: var(--radix-popover-content-transform-origin);
}
.origin-\\[--radix-select-content-transform-origin\\]{
  transform-origin: var(--radix-select-content-transform-origin);
}
.origin-\\[--radix-tooltip-content-transform-origin\\]{
  transform-origin: var(--radix-tooltip-content-transform-origin);
}
.origin-top-left{
  transform-origin: top left;
}
.origin-top-right{
  transform-origin: top right;
}
.-translate-x-1{
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\]{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0{
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-3{
  --tw-translate-y: 0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\]{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90{
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45{
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-110{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[0\\.74\\]{
  --tw-scale-x: 0.74;
  --tw-scale-y: 0.74;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes ping{

  75%, 100%{
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping{
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes pulse{

  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-col-resize{
  cursor: col-resize;
}
.cursor-default{
  cursor: default;
}
.cursor-grab{
  cursor: grab;
}
.cursor-move{
  cursor: move;
}
.cursor-pointer{
  cursor: pointer;
}
.touch-none{
  touch-action: none;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.select-all{
  -webkit-user-select: all;
          user-select: all;
}
.resize-none{
  resize: none;
}
.resize{
  resize: both;
}
.scroll-mt-16{
  scroll-margin-top: 4rem;
}
.scroll-mt-24{
  scroll-margin-top: 6rem;
}
.scroll-mt-28{
  scroll-margin-top: 7rem;
}
.scroll-mt-6{
  scroll-margin-top: 1.5rem;
}
.list-disc{
  list-style-type: disc;
}
.list-none{
  list-style-type: none;
}
.grid-cols-12{
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-\\[6\\.5rem_1fr_auto\\]{
  grid-template-columns: 6.5rem 1fr auto;
}
.grid-cols-\\[9rem_1fr_5\\.5rem\\]{
  grid-template-columns: 9rem 1fr 5.5rem;
}
.grid-cols-\\[minmax\\(0\\2c 14rem\\)_1fr_auto\\]{
  grid-template-columns: minmax(0,14rem) 1fr auto;
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.flex-col-reverse{
  flex-direction: column-reverse;
}
.flex-wrap{
  flex-wrap: wrap;
}
.place-items-center{
  place-items: center;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-baseline{
  align-items: baseline;
}
.items-stretch{
  align-items: stretch;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.gap-0\\.5{
  gap: 0.125rem;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-10{
  gap: 2.5rem;
}
.gap-12{
  gap: 3rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-2\\.5{
  gap: 0.625rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-3\\.5{
  gap: 0.875rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-7{
  gap: 1.75rem;
}
.gap-8{
  gap: 2rem;
}
.gap-x-12{
  column-gap: 3rem;
}
.gap-x-2{
  column-gap: 0.5rem;
}
.gap-x-3{
  column-gap: 0.75rem;
}
.gap-x-4{
  column-gap: 1rem;
}
.gap-x-5{
  column-gap: 1.25rem;
}
.gap-x-6{
  column-gap: 1.5rem;
}
.gap-x-8{
  column-gap: 2rem;
}
.gap-y-1{
  row-gap: 0.25rem;
}
.gap-y-1\\.5{
  row-gap: 0.375rem;
}
.gap-y-10{
  row-gap: 2.5rem;
}
.gap-y-2{
  row-gap: 0.5rem;
}
.gap-y-5{
  row-gap: 1.25rem;
}
.gap-y-8{
  row-gap: 2rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-10 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2.5rem * var(--tw-space-y-reverse));
}
.space-y-14 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(3.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(3.5rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-2\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-3\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.875rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.875rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-paper-deep > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(242 236 225 / var(--tw-divide-opacity, 1));
}
.divide-sand > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(228 219 204 / var(--tw-divide-opacity, 1));
}
.self-start{
  align-self: flex-start;
}
.self-center{
  align-self: center;
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-visible{
  overflow: visible;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre-wrap{
  white-space: pre-wrap;
}
.break-words{
  overflow-wrap: break-word;
}
.break-all{
  word-break: break-all;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-\\[1px\\]{
  border-radius: 1px;
}
.rounded-\\[2px\\]{
  border-radius: 2px;
}
.rounded-\\[50\\%\\]{
  border-radius: 50%;
}
.rounded-\\[inherit\\]{
  border-radius: inherit;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: var(--radius);
}
.rounded-md{
  border-radius: calc(var(--radius) - 2px);
}
.rounded-sm{
  border-radius: calc(var(--radius) - 4px);
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-r-sm{
  border-top-right-radius: calc(var(--radius) - 4px);
  border-bottom-right-radius: calc(var(--radius) - 4px);
}
.rounded-t-\\[10px\\]{
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.rounded-tl-sm{
  border-top-left-radius: calc(var(--radius) - 4px);
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-2{
  border-width: 2px;
}
.border-y{
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-\\[3px\\]{
  border-bottom-width: 3px;
}
.border-l{
  border-left-width: 1px;
}
.border-l-2{
  border-left-width: 2px;
}
.border-l-\\[3px\\]{
  border-left-width: 3px;
}
.border-r{
  border-right-width: 1px;
}
.border-t{
  border-top-width: 1px;
}
.border-t-4{
  border-top-width: 4px;
}
.border-dashed{
  border-style: dashed;
}
.border-\\[rgba\\(88\\2c 140\\2c 255\\2c 0\\.40\\)\\]{
  border-color: rgba(88,140,255,0.40);
}
.border-amber-200{
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-amber-300{
  --tw-border-opacity: 1;
  border-color: rgb(252 211 77 / var(--tw-border-opacity, 1));
}
.border-amber-500{
  --tw-border-opacity: 1;
  border-color: rgb(245 158 11 / var(--tw-border-opacity, 1));
}
.border-blue-200{
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.border-brand{
  --tw-border-opacity: 1;
  border-color: rgb(0 47 167 / var(--tw-border-opacity, 1));
}
.border-brand\\/35{
  border-color: rgb(0 47 167 / 0.35);
}
.border-brand\\/40{
  border-color: rgb(0 47 167 / 0.4);
}
.border-current{
  border-color: currentColor;
}
.border-dawn-300{
  --tw-border-opacity: 1;
  border-color: rgb(255 195 157 / var(--tw-border-opacity, 1));
}
.border-dawn-500{
  --tw-border-opacity: 1;
  border-color: rgb(255 143 94 / var(--tw-border-opacity, 1));
}
.border-destructive{
  border-color: hsl(var(--destructive));
}
.border-destructive\\/50{
  border-color: hsl(var(--destructive) / 0.5);
}
.border-emerald-200{
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.border-emerald-300{
  --tw-border-opacity: 1;
  border-color: rgb(110 231 183 / var(--tw-border-opacity, 1));
}
.border-emerald-400{
  --tw-border-opacity: 1;
  border-color: rgb(52 211 153 / var(--tw-border-opacity, 1));
}
.border-flag{
  --tw-border-opacity: 1;
  border-color: rgb(180 83 9 / var(--tw-border-opacity, 1));
}
.border-flag\\/40{
  border-color: rgb(180 83 9 / 0.4);
}
.border-indigo-200{
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity, 1));
}
.border-input{
  border-color: hsl(var(--input));
}
.border-night{
  --tw-border-opacity: 1;
  border-color: rgb(8 11 24 / var(--tw-border-opacity, 1));
}
.border-night-lift{
  --tw-border-opacity: 1;
  border-color: rgb(14 19 38 / var(--tw-border-opacity, 1));
}
.border-paper{
  --tw-border-opacity: 1;
  border-color: rgb(250 247 241 / var(--tw-border-opacity, 1));
}
.border-paper-deep{
  --tw-border-opacity: 1;
  border-color: rgb(242 236 225 / var(--tw-border-opacity, 1));
}
.border-primary{
  border-color: hsl(var(--primary));
}
.border-primary\\/50{
  border-color: hsl(var(--primary) / 0.5);
}
.border-rose-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 205 211 / var(--tw-border-opacity, 1));
}
.border-rose-300{
  --tw-border-opacity: 1;
  border-color: rgb(253 164 175 / var(--tw-border-opacity, 1));
}
.border-sand{
  --tw-border-opacity: 1;
  border-color: rgb(228 219 204 / var(--tw-border-opacity, 1));
}
.border-sand\\/70{
  border-color: rgb(228 219 204 / 0.7);
}
.border-sky-200{
  --tw-border-opacity: 1;
  border-color: rgb(186 230 253 / var(--tw-border-opacity, 1));
}
.border-sky-300{
  --tw-border-opacity: 1;
  border-color: rgb(125 211 252 / var(--tw-border-opacity, 1));
}
.border-stone-400{
  --tw-border-opacity: 1;
  border-color: rgb(168 162 158 / var(--tw-border-opacity, 1));
}
.border-stone-400\\/70{
  border-color: rgb(168 162 158 / 0.7);
}
.border-stone-900{
  --tw-border-opacity: 1;
  border-color: rgb(28 25 23 / var(--tw-border-opacity, 1));
}
.border-stone-950\\/15{
  border-color: rgb(12 10 9 / 0.15);
}
.border-transparent{
  border-color: transparent;
}
.border-verified{
  --tw-border-opacity: 1;
  border-color: rgb(4 120 87 / var(--tw-border-opacity, 1));
}
.border-verified\\/30{
  border-color: rgb(4 120 87 / 0.3);
}
.border-verified\\/40{
  border-color: rgb(4 120 87 / 0.4);
}
.border-verified\\/50{
  border-color: rgb(4 120 87 / 0.5);
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/10{
  border-color: rgb(255 255 255 / 0.1);
}
.border-white\\/15{
  border-color: rgb(255 255 255 / 0.15);
}
.border-white\\/20{
  border-color: rgb(255 255 255 / 0.2);
}
.border-white\\/25{
  border-color: rgb(255 255 255 / 0.25);
}
.border-l-brand{
  --tw-border-opacity: 1;
  border-left-color: rgb(0 47 167 / var(--tw-border-opacity, 1));
}
.border-l-transparent{
  border-left-color: transparent;
}
.border-t-amber-500{
  --tw-border-opacity: 1;
  border-top-color: rgb(245 158 11 / var(--tw-border-opacity, 1));
}
.border-t-blue-500{
  --tw-border-opacity: 1;
  border-top-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-t-brand{
  --tw-border-opacity: 1;
  border-top-color: rgb(0 47 167 / var(--tw-border-opacity, 1));
}
.border-t-emerald-500{
  --tw-border-opacity: 1;
  border-top-color: rgb(16 185 129 / var(--tw-border-opacity, 1));
}
.border-t-indigo-500{
  --tw-border-opacity: 1;
  border-top-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.border-t-rose-500{
  --tw-border-opacity: 1;
  border-top-color: rgb(244 63 94 / var(--tw-border-opacity, 1));
}
.border-t-sand{
  --tw-border-opacity: 1;
  border-top-color: rgb(228 219 204 / var(--tw-border-opacity, 1));
}
.border-t-stone-400{
  --tw-border-opacity: 1;
  border-top-color: rgb(168 162 158 / var(--tw-border-opacity, 1));
}
.border-t-transparent{
  border-top-color: transparent;
}
.bg-\\[\\#5ee9b5\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(94 233 181 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#a9c2ff\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(169 194 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[rgba\\(169\\2c 194\\2c 255\\2c 0\\.4\\)\\]{
  background-color: rgba(169,194,255,0.4);
}
.bg-\\[rgba\\(88\\2c 140\\2c 255\\2c 0\\.10\\)\\]{
  background-color: rgba(88,140,255,0.10);
}
.bg-accent{
  background-color: hsl(var(--accent));
}
.bg-amber-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-amber-400{
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity, 1));
}
.bg-amber-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-amber-500{
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-amber-950{
  --tw-bg-opacity: 1;
  background-color: rgb(69 26 3 / var(--tw-bg-opacity, 1));
}
.bg-background{
  background-color: hsl(var(--background));
}
.bg-black\\/80{
  background-color: rgb(0 0 0 / 0.8);
}
.bg-blue-100{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-50{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-50\\/40{
  background-color: rgb(239 246 255 / 0.4);
}
.bg-border{
  background-color: hsl(var(--border));
}
.bg-brand{
  --tw-bg-opacity: 1;
  background-color: rgb(0 47 167 / var(--tw-bg-opacity, 1));
}
.bg-brand\\/10{
  background-color: rgb(0 47 167 / 0.1);
}
.bg-brand\\/5{
  background-color: rgb(0 47 167 / 0.05);
}
.bg-card{
  background-color: hsl(var(--card));
}
.bg-dawn-100{
  --tw-bg-opacity: 1;
  background-color: rgb(255 233 214 / var(--tw-bg-opacity, 1));
}
.bg-dawn-100\\/60{
  background-color: rgb(255 233 214 / 0.6);
}
.bg-dawn-100\\/70{
  background-color: rgb(255 233 214 / 0.7);
}
.bg-dawn-300{
  --tw-bg-opacity: 1;
  background-color: rgb(255 195 157 / var(--tw-bg-opacity, 1));
}
.bg-dawn-500{
  --tw-bg-opacity: 1;
  background-color: rgb(255 143 94 / var(--tw-bg-opacity, 1));
}
.bg-dawn-700{
  --tw-bg-opacity: 1;
  background-color: rgb(217 83 31 / var(--tw-bg-opacity, 1));
}
.bg-destructive{
  background-color: hsl(var(--destructive));
}
.bg-emerald-100{
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.bg-emerald-400{
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity, 1));
}
.bg-emerald-400\\/15{
  background-color: rgb(52 211 153 / 0.15);
}
.bg-emerald-50{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50\\/40{
  background-color: rgb(236 253 245 / 0.4);
}
.bg-emerald-500{
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.bg-emerald-600{
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.bg-flag{
  --tw-bg-opacity: 1;
  background-color: rgb(180 83 9 / var(--tw-bg-opacity, 1));
}
.bg-flag\\/5{
  background-color: rgb(180 83 9 / 0.05);
}
.bg-flag\\/\\[0\\.08\\]{
  background-color: rgb(180 83 9 / 0.08);
}
.bg-foreground{
  background-color: hsl(var(--foreground));
}
.bg-indigo-50{
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.bg-ink{
  --tw-bg-opacity: 1;
  background-color: rgb(10 10 11 / var(--tw-bg-opacity, 1));
}
.bg-muted{
  background-color: hsl(var(--muted));
}
.bg-muted\\/50{
  background-color: hsl(var(--muted) / 0.5);
}
.bg-night{
  --tw-bg-opacity: 1;
  background-color: rgb(8 11 24 / var(--tw-bg-opacity, 1));
}
.bg-night-deep{
  --tw-bg-opacity: 1;
  background-color: rgb(5 7 15 / var(--tw-bg-opacity, 1));
}
.bg-night-lift{
  --tw-bg-opacity: 1;
  background-color: rgb(14 19 38 / var(--tw-bg-opacity, 1));
}
.bg-night-lift\\/90{
  background-color: rgb(14 19 38 / 0.9);
}
.bg-night\\/40{
  background-color: rgb(8 11 24 / 0.4);
}
.bg-night\\/50{
  background-color: rgb(8 11 24 / 0.5);
}
.bg-paper{
  --tw-bg-opacity: 1;
  background-color: rgb(250 247 241 / var(--tw-bg-opacity, 1));
}
.bg-paper-deep{
  --tw-bg-opacity: 1;
  background-color: rgb(242 236 225 / var(--tw-bg-opacity, 1));
}
.bg-paper-deep\\/95{
  background-color: rgb(242 236 225 / 0.95);
}
.bg-paper\\/50{
  background-color: rgb(250 247 241 / 0.5);
}
.bg-paper\\/60{
  background-color: rgb(250 247 241 / 0.6);
}
.bg-paper\\/80{
  background-color: rgb(250 247 241 / 0.8);
}
.bg-paper\\/85{
  background-color: rgb(250 247 241 / 0.85);
}
.bg-paper\\/95{
  background-color: rgb(250 247 241 / 0.95);
}
.bg-popover{
  background-color: hsl(var(--popover));
}
.bg-primary{
  background-color: hsl(var(--primary));
}
.bg-primary\\/10{
  background-color: hsl(var(--primary) / 0.1);
}
.bg-primary\\/20{
  background-color: hsl(var(--primary) / 0.2);
}
.bg-rose-100{
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / var(--tw-bg-opacity, 1));
}
.bg-rose-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}
.bg-rose-50\\/40{
  background-color: rgb(255 241 242 / 0.4);
}
.bg-rose-50\\/50{
  background-color: rgb(255 241 242 / 0.5);
}
.bg-rose-500{
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / var(--tw-bg-opacity, 1));
}
.bg-rose-600{
  --tw-bg-opacity: 1;
  background-color: rgb(225 29 72 / var(--tw-bg-opacity, 1));
}
.bg-sand{
  --tw-bg-opacity: 1;
  background-color: rgb(228 219 204 / var(--tw-bg-opacity, 1));
}
.bg-sand\\/40{
  background-color: rgb(228 219 204 / 0.4);
}
.bg-secondary{
  background-color: hsl(var(--secondary));
}
.bg-sky-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 255 / var(--tw-bg-opacity, 1));
}
.bg-stone-100{
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 244 / var(--tw-bg-opacity, 1));
}
.bg-stone-400{
  --tw-bg-opacity: 1;
  background-color: rgb(168 162 158 / var(--tw-bg-opacity, 1));
}
.bg-stone-500{
  --tw-bg-opacity: 1;
  background-color: rgb(120 113 108 / var(--tw-bg-opacity, 1));
}
.bg-stone-700{
  --tw-bg-opacity: 1;
  background-color: rgb(68 64 60 / var(--tw-bg-opacity, 1));
}
.bg-stone-900{
  --tw-bg-opacity: 1;
  background-color: rgb(28 25 23 / var(--tw-bg-opacity, 1));
}
.bg-stone-950{
  --tw-bg-opacity: 1;
  background-color: rgb(12 10 9 / var(--tw-bg-opacity, 1));
}
.bg-transparent{
  background-color: transparent;
}
.bg-verified{
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity, 1));
}
.bg-verified\\/10{
  background-color: rgb(4 120 87 / 0.1);
}
.bg-verified\\/5{
  background-color: rgb(4 120 87 / 0.05);
}
.bg-verified\\/\\[0\\.04\\]{
  background-color: rgb(4 120 87 / 0.04);
}
.bg-verified\\/\\[0\\.07\\]{
  background-color: rgb(4 120 87 / 0.07);
}
.bg-verified\\/\\[0\\.13\\]{
  background-color: rgb(4 120 87 / 0.13);
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10{
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/15{
  background-color: rgb(255 255 255 / 0.15);
}
.bg-white\\/20{
  background-color: rgb(255 255 255 / 0.2);
}
.bg-white\\/60{
  background-color: rgb(255 255 255 / 0.6);
}
.bg-white\\/70{
  background-color: rgb(255 255 255 / 0.7);
}
.bg-white\\/90{
  background-color: rgb(255 255 255 / 0.9);
}
.bg-white\\/\\[0\\.03\\]{
  background-color: rgb(255 255 255 / 0.03);
}
.bg-white\\/\\[0\\.04\\]{
  background-color: rgb(255 255 255 / 0.04);
}
.bg-white\\/\\[0\\.05\\]{
  background-color: rgb(255 255 255 / 0.05);
}
.bg-white\\/\\[0\\.06\\]{
  background-color: rgb(255 255 255 / 0.06);
}
.bg-\\[linear-gradient\\(100deg\\2c transparent_35\\%\\2c rgba\\(255\\2c 255\\2c 255\\2c 0\\.75\\)_50\\%\\2c transparent_65\\%\\)\\]{
  background-image: linear-gradient(100deg,transparent 35%,rgba(255,255,255,0.75) 50%,transparent 65%);
}
.bg-\\[radial-gradient\\(70\\%_120\\%_at_18\\%_0\\%\\2c \\#ff8f5e_0\\%\\2c \\#ffc39d_35\\%\\2c transparent_78\\%\\)\\]{
  background-image: radial-gradient(70% 120% at 18% 0%,#ff8f5e 0%,#ffc39d 35%,transparent 78%);
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-t{
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.from-dawn-500\\/70{
  --tw-gradient-from: rgb(255 143 94 / 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 143 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-night\\/60{
  --tw-gradient-from: rgb(8 11 24 / 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(8 11 24 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white\\/30{
  --tw-gradient-from: rgb(255 255 255 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-dawn-300\\/40{
  --tw-gradient-to: rgb(255 195 157 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(255 195 157 / 0.4) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-night\\/5{
  --tw-gradient-to: rgb(8 11 24 / 0.05) var(--tw-gradient-to-position);
}
.to-transparent{
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.fill-current{
  fill: currentColor;
}
.fill-primary{
  fill: hsl(var(--primary));
}
.object-cover{
  object-fit: cover;
}
.p-0{
  padding: 0px;
}
.p-0\\.5{
  padding: 0.125rem;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-10{
  padding: 2.5rem;
}
.p-12{
  padding: 3rem;
}
.p-2{
  padding: 0.5rem;
}
.p-2\\.5{
  padding: 0.625rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-7{
  padding: 1.75rem;
}
.p-8{
  padding: 2rem;
}
.p-\\[1px\\]{
  padding: 1px;
}
.px-0\\.5{
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-12{
  padding-left: 3rem;
  padding-right: 3rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5{
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7{
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-14{
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5{
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-7{
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-9{
  padding-top: 2.25rem;
  padding-bottom: 2.25rem;
}
.pb-1\\.5{
  padding-bottom: 0.375rem;
}
.pb-10{
  padding-bottom: 2.5rem;
}
.pb-14{
  padding-bottom: 3.5rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-24{
  padding-bottom: 6rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-5{
  padding-bottom: 1.25rem;
}
.pb-8{
  padding-bottom: 2rem;
}
.pb-\\[210px\\]{
  padding-bottom: 210px;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-2\\.5{
  padding-left: 0.625rem;
}
.pl-3{
  padding-left: 0.75rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-6{
  padding-left: 1.5rem;
}
.pl-8{
  padding-left: 2rem;
}
.pl-9{
  padding-left: 2.25rem;
}
.pr-1{
  padding-right: 0.25rem;
}
.pr-10{
  padding-right: 2.5rem;
}
.pr-14{
  padding-right: 3.5rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-2\\.5{
  padding-right: 0.625rem;
}
.pr-6{
  padding-right: 1.5rem;
}
.pr-8{
  padding-right: 2rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-0\\.5{
  padding-top: 0.125rem;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-10{
  padding-top: 2.5rem;
}
.pt-12{
  padding-top: 3rem;
}
.pt-16{
  padding-top: 4rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-6{
  padding-top: 1.5rem;
}
.pt-8{
  padding-top: 2rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.align-top{
  vertical-align: top;
}
.align-middle{
  vertical-align: middle;
}
.font-display{
  font-family: Zodiak, ui-serif, Georgia, serif;
}
.font-mono{
  font-family: "JetBrains Mono", ui-monospace, SFMono-Regular, monospace;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl{
  font-size: 3rem;
  line-height: 1;
}
.text-6xl{
  font-size: 3.75rem;
  line-height: 1;
}
.text-\\[0\\.8rem\\]{
  font-size: 0.8rem;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[12px\\]{
  font-size: 12px;
}
.text-\\[13px\\]{
  font-size: 13px;
}
.text-\\[14px\\]{
  font-size: 14px;
}
.text-\\[15px\\]{
  font-size: 15px;
}
.text-\\[38px\\]{
  font-size: 38px;
}
.text-\\[52px\\]{
  font-size: 52px;
}
.text-\\[9px\\]{
  font-size: 9px;
}
.text-\\[clamp\\(2\\.4rem\\2c 6\\.4vw\\2c 5\\.2rem\\)\\]{
  font-size: clamp(2.4rem,6.4vw,5.2rem);
}
.text-\\[clamp\\(2\\.6rem\\2c 7\\.2vw\\2c 6rem\\)\\]{
  font-size: clamp(2.6rem,7.2vw,6rem);
}
.text-\\[length\\:var\\(--type-h1\\)\\]{
  font-size: var(--type-h1);
}
.text-\\[length\\:var\\(--type-h2\\)\\]{
  font-size: var(--type-h2);
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold{
  font-weight: 700;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.lowercase{
  text-transform: lowercase;
}
.capitalize{
  text-transform: capitalize;
}
.normal-case{
  text-transform: none;
}
.italic{
  font-style: italic;
}
.not-italic{
  font-style: normal;
}
.tabular-nums{
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-\\[0\\.92\\]{
  line-height: 0.92;
}
.leading-\\[0\\.95\\]{
  line-height: 0.95;
}
.leading-\\[1\\.02\\]{
  line-height: 1.02;
}
.leading-\\[1\\.05\\]{
  line-height: 1.05;
}
.leading-\\[1\\.1\\]{
  line-height: 1.1;
}
.leading-\\[1\\.75\\]{
  line-height: 1.75;
}
.leading-\\[1\\]{
  line-height: 1;
}
.leading-none{
  line-height: 1;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-snug{
  line-height: 1.375;
}
.tracking-\\[-0\\.045em\\]{
  letter-spacing: -0.045em;
}
.tracking-\\[0\\.08em\\]{
  letter-spacing: 0.08em;
}
.tracking-\\[0\\.12em\\]{
  letter-spacing: 0.12em;
}
.tracking-\\[0\\.14em\\]{
  letter-spacing: 0.14em;
}
.tracking-\\[0\\.15em\\]{
  letter-spacing: 0.15em;
}
.tracking-\\[0\\.16em\\]{
  letter-spacing: 0.16em;
}
.tracking-\\[0\\.18em\\]{
  letter-spacing: 0.18em;
}
.tracking-\\[0\\.1em\\]{
  letter-spacing: 0.1em;
}
.tracking-\\[0\\.2em\\]{
  letter-spacing: 0.2em;
}
.tracking-\\[var\\(--tracking-display\\)\\]{
  letter-spacing: var(--tracking-display);
}
.tracking-normal{
  letter-spacing: 0em;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-tighter{
  letter-spacing: -0.05em;
}
.tracking-wider{
  letter-spacing: 0.05em;
}
.tracking-widest{
  letter-spacing: 0.1em;
}
.text-\\[\\#5ee9b5\\]{
  --tw-text-opacity: 1;
  color: rgb(94 233 181 / var(--tw-text-opacity, 1));
}
.text-\\[\\#a9c2ff\\]{
  --tw-text-opacity: 1;
  color: rgb(169 194 255 / var(--tw-text-opacity, 1));
}
.text-accent-foreground{
  color: hsl(var(--accent-foreground));
}
.text-amber-50{
  --tw-text-opacity: 1;
  color: rgb(255 251 235 / var(--tw-text-opacity, 1));
}
.text-amber-500{
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.text-amber-600{
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-amber-700{
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-amber-800{
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.text-amber-900{
  --tw-text-opacity: 1;
  color: rgb(120 53 15 / var(--tw-text-opacity, 1));
}
.text-amber-950{
  --tw-text-opacity: 1;
  color: rgb(69 26 3 / var(--tw-text-opacity, 1));
}
.text-blue-800{
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.text-brand{
  --tw-text-opacity: 1;
  color: rgb(0 47 167 / var(--tw-text-opacity, 1));
}
.text-card-foreground{
  color: hsl(var(--card-foreground));
}
.text-current{
  color: currentColor;
}
.text-dawn-300{
  --tw-text-opacity: 1;
  color: rgb(255 195 157 / var(--tw-text-opacity, 1));
}
.text-dawn-700{
  --tw-text-opacity: 1;
  color: rgb(217 83 31 / var(--tw-text-opacity, 1));
}
.text-dawn-800{
  --tw-text-opacity: 1;
  color: rgb(168 60 25 / var(--tw-text-opacity, 1));
}
.text-destructive{
  color: hsl(var(--destructive));
}
.text-destructive-foreground{
  color: hsl(var(--destructive-foreground));
}
.text-emerald-300{
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity, 1));
}
.text-emerald-600{
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.text-emerald-700{
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.text-emerald-800{
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}
.text-emerald-900{
  --tw-text-opacity: 1;
  color: rgb(6 78 59 / var(--tw-text-opacity, 1));
}
.text-flag{
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-foreground{
  color: hsl(var(--foreground));
}
.text-foreground\\/50{
  color: hsl(var(--foreground) / 0.5);
}
.text-indigo-800{
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity, 1));
}
.text-ink{
  --tw-text-opacity: 1;
  color: rgb(10 10 11 / var(--tw-text-opacity, 1));
}
.text-muted-foreground{
  color: hsl(var(--muted-foreground));
}
.text-night{
  --tw-text-opacity: 1;
  color: rgb(8 11 24 / var(--tw-text-opacity, 1));
}
.text-popover-foreground{
  color: hsl(var(--popover-foreground));
}
.text-primary{
  color: hsl(var(--primary));
}
.text-primary-foreground{
  color: hsl(var(--primary-foreground));
}
.text-rose-600{
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}
.text-rose-700{
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity, 1));
}
.text-rose-800{
  --tw-text-opacity: 1;
  color: rgb(159 18 57 / var(--tw-text-opacity, 1));
}
.text-rose-900{
  --tw-text-opacity: 1;
  color: rgb(136 19 55 / var(--tw-text-opacity, 1));
}
.text-sand{
  --tw-text-opacity: 1;
  color: rgb(228 219 204 / var(--tw-text-opacity, 1));
}
.text-secondary-foreground{
  color: hsl(var(--secondary-foreground));
}
.text-sky-600{
  --tw-text-opacity: 1;
  color: rgb(2 132 199 / var(--tw-text-opacity, 1));
}
.text-sky-700{
  --tw-text-opacity: 1;
  color: rgb(3 105 161 / var(--tw-text-opacity, 1));
}
.text-sky-800{
  --tw-text-opacity: 1;
  color: rgb(7 89 133 / var(--tw-text-opacity, 1));
}
.text-sky-900{
  --tw-text-opacity: 1;
  color: rgb(12 74 110 / var(--tw-text-opacity, 1));
}
.text-stone-300{
  --tw-text-opacity: 1;
  color: rgb(214 211 209 / var(--tw-text-opacity, 1));
}
.text-stone-400{
  --tw-text-opacity: 1;
  color: rgb(168 162 158 / var(--tw-text-opacity, 1));
}
.text-stone-500{
  --tw-text-opacity: 1;
  color: rgb(120 113 108 / var(--tw-text-opacity, 1));
}
.text-stone-600{
  --tw-text-opacity: 1;
  color: rgb(87 83 78 / var(--tw-text-opacity, 1));
}
.text-stone-700{
  --tw-text-opacity: 1;
  color: rgb(68 64 60 / var(--tw-text-opacity, 1));
}
.text-stone-800{
  --tw-text-opacity: 1;
  color: rgb(41 37 36 / var(--tw-text-opacity, 1));
}
.text-stone-900{
  --tw-text-opacity: 1;
  color: rgb(28 25 23 / var(--tw-text-opacity, 1));
}
.text-stone-950{
  --tw-text-opacity: 1;
  color: rgb(12 10 9 / var(--tw-text-opacity, 1));
}
.text-verified{
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/35{
  color: rgb(255 255 255 / 0.35);
}
.text-white\\/40{
  color: rgb(255 255 255 / 0.4);
}
.text-white\\/45{
  color: rgb(255 255 255 / 0.45);
}
.text-white\\/50{
  color: rgb(255 255 255 / 0.5);
}
.text-white\\/55{
  color: rgb(255 255 255 / 0.55);
}
.text-white\\/60{
  color: rgb(255 255 255 / 0.6);
}
.text-white\\/70{
  color: rgb(255 255 255 / 0.7);
}
.text-white\\/75{
  color: rgb(255 255 255 / 0.75);
}
.text-white\\/80{
  color: rgb(255 255 255 / 0.8);
}
.text-white\\/85{
  color: rgb(255 255 255 / 0.85);
}
.text-white\\/90{
  color: rgb(255 255 255 / 0.9);
}
.text-zinc-500{
  --tw-text-opacity: 1;
  color: rgb(113 113 122 / var(--tw-text-opacity, 1));
}
.underline{
  text-decoration-line: underline;
}
.line-through{
  text-decoration-line: line-through;
}
.decoration-stone-400{
  text-decoration-color: #a8a29e;
}
.decoration-white\\/25{
  text-decoration-color: rgb(255 255 255 / 0.25);
}
.decoration-white\\/30{
  text-decoration-color: rgb(255 255 255 / 0.3);
}
.decoration-white\\/40{
  text-decoration-color: rgb(255 255 255 / 0.4);
}
.decoration-white\\/50{
  text-decoration-color: rgb(255 255 255 / 0.5);
}
.underline-offset-2{
  text-underline-offset: 2px;
}
.underline-offset-4{
  text-underline-offset: 4px;
}
.accent-brand{
  accent-color: #002fa7;
}
.opacity-0{
  opacity: 0;
}
.opacity-100{
  opacity: 1;
}
.opacity-40{
  opacity: 0.4;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-70{
  opacity: 0.7;
}
.opacity-75{
  opacity: 0.75;
}
.opacity-80{
  opacity: 0.8;
}
.opacity-90{
  opacity: 0.9;
}
.opacity-\\[0\\.045\\]{
  opacity: 0.045;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_-10px_30px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.25\\)\\]{
  --tw-shadow: 0 -10px 30px rgba(0,0,0,0.25);
  --tw-shadow-colored: 0 -10px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_0_rgba\\(255\\2c 143\\2c 94\\2c 0\\)\\]{
  --tw-shadow: 0 0 0 0 rgba(255,143,94,0);
  --tw-shadow-colored: 0 0 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_12px_2px_rgba\\(255\\2c 143\\2c 94\\2c 0\\.55\\)\\]{
  --tw-shadow: 0 0 12px 2px rgba(255,143,94,0.55);
  --tw-shadow-colored: 0 0 12px 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_18px_50px_-24px_rgba\\(217\\2c 83\\2c 31\\2c 0\\.45\\)\\]{
  --tw-shadow: 0 18px 50px -24px rgba(217,83,31,0.45);
  --tw-shadow-colored: 0 18px 50px -24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_0_rgba\\(9\\2c 9\\2c 11\\2c 0\\.04\\)\\2c 0_12px_32px_-12px_rgba\\(0\\2c 47\\2c 167\\2c 0\\.18\\)\\]{
  --tw-shadow: 0 1px 0 rgba(9,9,11,0.04),0 12px 32px -12px rgba(0,47,167,0.18);
  --tw-shadow-colored: 0 1px 0 var(--tw-shadow-color), 0 12px 32px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_28px_64px_-20px_rgba\\(5\\2c 7\\2c 15\\2c 0\\.55\\)\\]{
  --tw-shadow: 0 28px 64px -20px rgba(5,7,15,0.55);
  --tw-shadow-colored: 0 28px 64px -20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_28px_64px_-30px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.9\\)\\]{
  --tw-shadow: 0 28px 64px -30px rgba(0,0,0,0.9);
  --tw-shadow-colored: 0 28px 64px -30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_30px_80px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.5\\)\\]{
  --tw-shadow: 0 30px 80px rgba(0,0,0,0.5);
  --tw-shadow-colored: 0 30px 80px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_3px_0_0_0_var\\(--brand\\)\\]{
  --tw-shadow: inset 3px 0 0 0 var(--brand);
  --tw-shadow-colored: inset 3px 0 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[var\\(--shadow-card\\)\\]{
  --tw-shadow-color: var(--shadow-card);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-\\[var\\(--shadow-lift\\)\\]{
  --tw-shadow-color: var(--shadow-lift);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.ring{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-0{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-4{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-\\[12px\\]{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(12px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-black\\/5{
  --tw-ring-color: rgb(0 0 0 / 0.05);
}
.ring-brand{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 47 167 / var(--tw-ring-opacity, 1));
}
.ring-brand\\/25{
  --tw-ring-color: rgb(0 47 167 / 0.25);
}
.ring-brand\\/30{
  --tw-ring-color: rgb(0 47 167 / 0.3);
}
.ring-dawn-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 233 214 / var(--tw-ring-opacity, 1));
}
.ring-dawn-300\\/80{
  --tw-ring-color: rgb(255 195 157 / 0.8);
}
.ring-dawn-500\\/20{
  --tw-ring-color: rgb(255 143 94 / 0.2);
}
.ring-ring{
  --tw-ring-color: hsl(var(--ring));
}
.ring-offset-background{
  --tw-ring-offset-color: hsl(var(--background));
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-3xl{
  --tw-blur: blur(64px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-xl{
  --tw-blur: blur(24px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.sepia{
  --tw-sepia: sepia(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur{
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md{
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl{
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[width\\]{
  transition-property: width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow{
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-1000{
  transition-duration: 1000ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
.duration-700{
  transition-duration: 700ms;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
@keyframes enter{

  from{
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes exit{

  to{
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
.animate-in{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.fade-in-0{
  --tw-enter-opacity: 0;
}
.zoom-in-95{
  --tw-enter-scale: .95;
}
.duration-1000{
  animation-duration: 1000ms;
}
.duration-200{
  animation-duration: 200ms;
}
.duration-300{
  animation-duration: 300ms;
}
.duration-500{
  animation-duration: 500ms;
}
.duration-700{
  animation-duration: 700ms;
}
.ease-in-out{
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out{
  animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.\\!running{
  animation-play-state: running !important;
}
.running{
  animation-play-state: running;
}
.paused{
  animation-play-state: paused;
}
.\\[margin-bottom\\:env\\(safe-area-inset-bottom\\)\\]{
  margin-bottom: env(safe-area-inset-bottom);
}
.\\[scrollbar-width\\:none\\]{
  scrollbar-width: none;
}
.\\[text-indent\\:-1\\.25rem\\]{
  text-indent: -1.25rem;
}

:root {
  --font-heading: "Cabinet Grotesk", ui-sans-serif, system-ui, sans-serif;
  --font-body: "Satoshi", ui-sans-serif, system-ui, sans-serif;
  /* Loaded at 401 only — italic 400. One cut, one job. */
  --font-display: "Zodiak", ui-serif, Georgia, serif;
  --brand: #002fa7;
  --brand-hover: #00237e;
  --accent-red: #e11d48;
  /* Daybreak. Mirrors tailwind.config.js so plain CSS (gradients, rings) can
     reach the same values without hard-coding them twice by eye. */
  --night: #080b18;
  --dawn-500: #ff8f5e;
  --dawn-700: #d9531f;
  /* One ring colour for the whole site. #d9531f is the only warm value that
     clears 3:1 against BOTH the paper sections (3.8:1) and the night sections
     (4.8:1) — a ring that is only visible on half the page is not a ring. */
  --focus-ring: #d9531f;
}

body {
  margin: 0;
  font-family: var(--font-body);
  /* Kerning is not optional — Butterick, and every type designer since. Off by
     default in some engines, which is why headline pairs like "Yo" and "Ta"
     were sitting loose. */
  font-kerning: normal;
  font-feature-settings: "kern" 1, "liga" 1;
  text-rendering: optimizeLegibility;
  /* 120-145% of point size. Browser default is ~117%, which is too tight for
     multi-line body copy at these sizes. */
  line-height: 1.55;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: hsl(var(--background));
  color: hsl(var(--foreground));
}

h1, h2, h3, h4, h5, h6 {
  font-family: var(--font-heading);
  letter-spacing: -0.02em;
}

::selection {
  background: #002fa7;
  color: #ffffff;
}

/* One visible focus style everywhere, replacing the per-component rings that
   existed on some controls and not others. Keyboard-only (:focus-visible), so
   it never fires on mouse clicks — the reason ad-hoc rings usually get removed. */
:focus-visible {
  outline: 2px solid hsl(var(--ring, 17 75% 49%));
  outline-offset: 2px;
  border-radius: 1px;
}

/* Motion is decoration here, never information: every animation on this site
   has a static state that says the same thing. So reduce means remove, not
   shorten. Belt-and-braces alongside the motion-safe: variants in the markup —
   this also catches third-party CSS we do not control. */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}

/* Subtle grid pattern for hero backgrounds */
.grid-pattern {
  background-image: linear-gradient(#e4e4e7 1px, transparent 1px),
    linear-gradient(90deg, #e4e4e7 1px, transparent 1px);
  background-size: 48px 48px;
  background-position: -1px -1px;
}

.u-label {
  font-size: var(--type-label);
  letter-spacing: var(--tracking-label);
  text-transform: uppercase;
  font-weight: 700;
  line-height: 1.4;
}

.font-heading { font-family: var(--font-heading); }
.font-body { font-family: var(--font-body); }

/* The emphasis word. Italic serif at display size next to a tight grotesk
   needs two corrections to sit right: optical size runs large, so it is scaled
   back slightly, and the italic's forward lean opens a gap on the left that has
   to be closed by hand. Without these it reads as a font-loading accident. */
.font-display {
  font-family: var(--font-display);
  font-style: italic;
  font-weight: 400;
  font-size: 0.94em;
  letter-spacing: -0.005em;
  margin-left: -0.02em;
  padding-right: 0.06em;
}

/* Score ring animation */
@keyframes ring-fill {
  from { stroke-dashoffset: 283; }
}
.animate-ring { animation: ring-fill 1s ease-out; }

/* Stagger fade for lists */
@keyframes fade-up {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}
.fade-up { animation: fade-up 0.4s ease-out both; }

/* Marquee shift for hero */
/* .text-brand / .bg-brand / .border-brand / .hover:bg-brand-hover are now
   generated by Tailwind from theme.extend.colors.brand (tailwind.config.js).
   Hand-writing them here covered only those four exact classes and silently
   dropped every other variant. */

/* Sharp scrollbar */
::-webkit-scrollbar { width: 10px; height: 10px; }
::-webkit-scrollbar-thumb { background: #d4d4d8; }
::-webkit-scrollbar-thumb:hover { background: #a1a1aa; }
::-webkit-scrollbar-track { background: #fafafa; }


/* Idle drift for the landing page's 3D stack. Deliberately slow and small:
   the object should feel physical, not animated. motion-safe: in the markup
   means prefers-reduced-motion switches it off entirely. */
/* One pass of light across the index horizon when the search page settles.
   Runs once, says nothing the band does not already say in numbers, and is
   applied under motion-safe: so a reduced-motion visitor simply gets the
   finished band. */
@keyframes horizonsweep {
  from { transform: translateX(-100%); }
  to   { transform: translateX(100%); }
}

@keyframes truthdrift {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  50%      { transform: translateY(-10px) rotate(-0.4deg); }
}

/* The landing page's one page-turn: a proximity snap out of the hero into
   the video band, and nothing else. \`proximity\`, not \`mandatory\`, so a
   reader stopped mid-hero is left alone; only the hero and the band carry
   an align, so the rest of the page scrolls freely. The class lives on
   <html> only while the landing page is mounted. */
html.snap-hero { scroll-snap-type: y proximity; }
html.snap-hero .snap-target { scroll-snap-align: start; }

/* ══════════════════════════════════════════════════════════════════════════
   Appearance (lib/appearance.jsx). Three attributes on <html>, present only
   while an app page is mounted: \`.dark\`, \`data-font\`, \`data-radius\`.
   Nothing here exists without them, so light mode is byte-identical.

   Night is a remap of the literal Daybreak utilities rather than a second
   set of tokens, because the app is written in \`bg-white\` / \`border-sand\` /
   \`text-stone-*\` in a hundred files. This block is the ONE place night
   lives: an outlier found on a page is fixed by adding it here, never at
   the call site. Rules follow Daybreak — the white ramp for text on night,
   never stone; dawn stays light and is never a status colour; the focus
   ring is unchanged. Values and contrast notes: the design spec
   (docs/superpowers/specs/2026-09-09-appearance-settings-design.md).
   ══════════════════════════════════════════════════════════════════════════ */
.dark { color-scheme: dark; }
.dark .bg-paper        { background-color: #080b18; }   /* night       — the canvas  */
.dark .bg-paper-deep   { background-color: #05070f; }   /* night-deep  — the sidebar */
.dark .bg-white        { background-color: #0e1326; }   /* night-lift  — every card  */
.dark .bg-night        { background-color: #182040; }   /* raised: active nav, chips */
.dark .bg-night-lift   { background-color: #242c52; }
.dark .bg-sand         { background-color: rgba(255, 255, 255, 0.18); }
.dark .bg-stone-50,
.dark .bg-stone-100    { background-color: rgba(255, 255, 255, 0.06); }
.dark .border-sand,
.dark .border-stone-200 { border-color: rgba(255, 255, 255, 0.14); }
.dark .border-paper-deep { border-color: rgba(255, 255, 255, 0.08); }
.dark .border-night    { border-color: rgba(255, 255, 255, 0.6); }   /* a selected card keeps its weight */
.dark .text-stone-950,
.dark .text-stone-900  { color: #ffffff; }
.dark .text-stone-700  { color: rgba(255, 255, 255, 0.78); }
.dark .text-stone-600  { color: rgba(255, 255, 255, 0.62); }
.dark .text-paper-deep { color: rgba(255, 255, 255, 0.12); }        /* the ring track */
.dark .hover\\:bg-sand:hover,
.dark .hover\\:bg-sand\\/70:hover { background-color: rgba(255, 255, 255, 0.08); }
.dark .hover\\:bg-paper:hover,
.dark .hover\\:bg-paper-deep:hover,
.dark .hover\\:bg-stone-50:hover { background-color: rgba(255, 255, 255, 0.06); }
.dark .hover\\:text-stone-900:hover,
.dark .hover\\:text-stone-950:hover { color: #ffffff; }
.dark .bg-brand        { background-color: #2f5fe0; }   /* white on it 5.5:1, on night 3.5:1 */
.dark .hover\\:bg-brand-hover:hover { background-color: #3f6ff0; }
.dark .text-brand      { color: #7c9cff; }
.dark .hover\\:text-brand:hover { color: #9db5ff; }
.dark .shadow-\\[var\\(--shadow-card\\)\\] { box-shadow: none; }
/* Status tints: the hue stays, the pastel goes. */
.dark .bg-emerald-50   { background-color: rgba(16, 185, 129, 0.14); }
.dark .text-emerald-700 { color: #6ee7b7; }
.dark .border-emerald-200 { border-color: rgba(110, 231, 183, 0.35); }
.dark .bg-amber-50     { background-color: rgba(245, 158, 11, 0.14); }
.dark .text-amber-700  { color: #fcd34d; }
.dark .border-amber-200 { border-color: rgba(252, 211, 77, 0.35); }
.dark .bg-sky-50       { background-color: rgba(14, 165, 233, 0.14); }
.dark .text-sky-700    { color: #7dd3fc; }
.dark .border-sky-200  { border-color: rgba(125, 211, 252, 0.35); }
.dark .bg-rose-50,
.dark .bg-rose-50\\/50  { background-color: rgba(225, 29, 72, 0.10); }
.dark .text-rose-700   { color: #fda4af; }
.dark .border-rose-200,
.dark .border-rose-300 { border-color: rgba(253, 164, 175, 0.35); }
.dark .hover\\:bg-rose-100:hover { background-color: rgba(225, 29, 72, 0.2); }

/* Alpha variants of the remapped surfaces. Tailwind emits these as
   rgb(<paper> / .6) and so on, which reads as a grey slab on night. */
.dark .bg-paper\\/50,
.dark .bg-paper\\/60,
.dark .bg-paper\\/85,
.dark .bg-paper\\/95   { background-color: rgba(8, 11, 24, 0.85); }
.dark .bg-paper-deep\\/95 { background-color: rgba(5, 7, 15, 0.95); }
.dark .bg-white\\/60,
.dark .bg-white\\/70,
.dark .bg-white\\/90   { background-color: rgba(14, 19, 38, 0.92); }
.dark .bg-sand\\/40,
.dark .bg-sand\\/60,
.dark .bg-sand\\/70    { background-color: rgba(255, 255, 255, 0.10); }
.dark .border-sand\\/70 { border-color: rgba(255, 255, 255, 0.14); }
/* The first-run tour offer: a dawn glow on night, not a tan block. */
.dark .bg-dawn-100\\/70,
.dark .hover\\:bg-dawn-100:hover { background-color: rgba(255, 143, 94, 0.16); }
/* The active tab in every TabsList that lifts it to white. */
.dark .data-\\[state\\=active\\]\\:bg-white[data-state="active"] { background-color: #182040; }
/* The remaining stone shades. */
.dark .text-stone-800  { color: rgba(255, 255, 255, 0.9); }
.dark .text-stone-500  { color: rgba(255, 255, 255, 0.55); }
.dark .text-stone-400  { color: rgba(255, 255, 255, 0.45); }
.dark .text-stone-300  { color: rgba(255, 255, 255, 0.35); }
.dark .hover\\:text-stone-800:hover { color: rgba(255, 255, 255, 0.9); }
.dark .border-stone-400,
.dark .border-stone-400\\/70,
.dark .hover\\:border-stone-400:hover { border-color: rgba(255, 255, 255, 0.3); }
.dark .placeholder\\:text-stone-500::placeholder { color: rgba(255, 255, 255, 0.4); }
/* Native form controls under color-scheme: dark get a grey UA background;
   the app draws its own. :where() keeps this at utility specificity so any
   explicit bg-* class, remapped or not, still wins. */
.dark :where(input:not([type="checkbox"]):not([type="radio"]), textarea, select) { background-color: transparent; }

/* Typeface. Three variables, already what every heading and body rule
   reads. The Zodiak emphasis word falls back to ui-serif under every
   alternative so the human word keeps a different voice. */
[data-font="geometric"] {
  --font-heading: "Outfit", ui-sans-serif, system-ui, sans-serif;
  --font-body: "Outfit", ui-sans-serif, system-ui, sans-serif;
  --font-display: ui-serif, Georgia, serif;
}
[data-font="neutral"] {
  --font-heading: "Inter", ui-sans-serif, system-ui, sans-serif;
  --font-body: "Inter", ui-sans-serif, system-ui, sans-serif;
  --font-display: ui-serif, Georgia, serif;
}
[data-font="system"] {
  --font-heading: ui-sans-serif, system-ui, -apple-system, "Segoe UI", sans-serif;
  --font-body: ui-sans-serif, system-ui, -apple-system, "Segoe UI", sans-serif;
  --font-display: ui-serif, Georgia, serif;
}

/* Corners. Tailwind's sm/md/lg all derive from --radius (sm = radius − 4px),
   so one variable moves every \`rounded-sm\` at once. \`rounded-full\` is
   untouched. sharp is today's value and stays the default. */
[data-radius="cut"]   { --radius: 0.375rem; }
[data-radius="soft"]  { --radius: 0.625rem; }
[data-radius="round"] { --radius: 1rem; }
.file\\:border-0::file-selector-button{
  border-width: 0px;
}
.file\\:bg-transparent::file-selector-button{
  background-color: transparent;
}
.file\\:text-sm::file-selector-button{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.file\\:font-medium::file-selector-button{
  font-weight: 500;
}
.file\\:text-foreground::file-selector-button{
  color: hsl(var(--foreground));
}
.placeholder\\:text-muted-foreground::placeholder{
  color: hsl(var(--muted-foreground));
}
.placeholder\\:text-stone-400::placeholder{
  --tw-text-opacity: 1;
  color: rgb(168 162 158 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-stone-500::placeholder{
  --tw-text-opacity: 1;
  color: rgb(120 113 108 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-stone-600::placeholder{
  --tw-text-opacity: 1;
  color: rgb(87 83 78 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-white\\/55::placeholder{
  color: rgb(255 255 255 / 0.55);
}
.after\\:absolute::after{
  content: var(--tw-content);
  position: absolute;
}
.after\\:inset-y-0::after{
  content: var(--tw-content);
  top: 0px;
  bottom: 0px;
}
.after\\:left-1\\/2::after{
  content: var(--tw-content);
  left: 50%;
}
.after\\:w-1::after{
  content: var(--tw-content);
  width: 0.25rem;
}
.after\\:-translate-x-1\\/2::after{
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.first\\:rounded-l-md:first-child{
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.first\\:border-l:first-child{
  border-left-width: 1px;
}
.first\\:border-t-0:first-child{
  border-top-width: 0px;
}
.first\\:pt-0:first-child{
  padding-top: 0px;
}
.last\\:rounded-r-md:last-child{
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.last\\:border-b-0:last-child{
  border-bottom-width: 0px;
}
.last\\:border-r-0:last-child{
  border-right-width: 0px;
}
.empty\\:hidden:empty{
  display: none;
}
.focus-within\\:relative:focus-within{
  position: relative;
}
.focus-within\\:z-20:focus-within{
  z-index: 20;
}
.focus-within\\:opacity-100:focus-within{
  opacity: 1;
}
.focus-within\\:ring-1:focus-within{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-within\\:ring-2:focus-within{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-within\\:ring-brand:focus-within{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 47 167 / var(--tw-ring-opacity, 1));
}
.focus-within\\:ring-offset-1:focus-within{
  --tw-ring-offset-width: 1px;
}
.hover\\:-translate-y-0\\.5:hover{
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:border-brand:hover{
  --tw-border-opacity: 1;
  border-color: rgb(0 47 167 / var(--tw-border-opacity, 1));
}
.hover\\:border-dawn-500:hover{
  --tw-border-opacity: 1;
  border-color: rgb(255 143 94 / var(--tw-border-opacity, 1));
}
.hover\\:border-night-lift:hover{
  --tw-border-opacity: 1;
  border-color: rgb(14 19 38 / var(--tw-border-opacity, 1));
}
.hover\\:border-stone-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(168 162 158 / var(--tw-border-opacity, 1));
}
.hover\\:bg-\\[\\#00237e\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(0 35 126 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-accent:hover{
  background-color: hsl(var(--accent));
}
.hover\\:bg-amber-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(120 53 15 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-black\\/5:hover{
  background-color: rgb(0 0 0 / 0.05);
}
.hover\\:bg-brand:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(0 47 167 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-brand-hover:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(0 35 126 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-dawn-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 233 214 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-dawn-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 195 157 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-dawn-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(168 60 25 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-destructive\\/80:hover{
  background-color: hsl(var(--destructive) / 0.8);
}
.hover\\:bg-destructive\\/90:hover{
  background-color: hsl(var(--destructive) / 0.9);
}
.hover\\:bg-emerald-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-muted:hover{
  background-color: hsl(var(--muted));
}
.hover\\:bg-muted\\/50:hover{
  background-color: hsl(var(--muted) / 0.5);
}
.hover\\:bg-night-lift:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(14 19 38 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-paper:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(250 247 241 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-paper-deep:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(242 236 225 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-primary:hover{
  background-color: hsl(var(--primary));
}
.hover\\:bg-primary\\/80:hover{
  background-color: hsl(var(--primary) / 0.8);
}
.hover\\:bg-primary\\/90:hover{
  background-color: hsl(var(--primary) / 0.9);
}
.hover\\:bg-rose-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-rose-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(190 18 60 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-sand:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(228 219 204 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-sand\\/60:hover{
  background-color: rgb(228 219 204 / 0.6);
}
.hover\\:bg-sand\\/70:hover{
  background-color: rgb(228 219 204 / 0.7);
}
.hover\\:bg-secondary:hover{
  background-color: hsl(var(--secondary));
}
.hover\\:bg-secondary\\/80:hover{
  background-color: hsl(var(--secondary) / 0.8);
}
.hover\\:bg-stone-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(41 37 36 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-white\\/10:hover{
  background-color: rgb(255 255 255 / 0.1);
}
.hover\\:text-accent-foreground:hover{
  color: hsl(var(--accent-foreground));
}
.hover\\:text-brand:hover{
  --tw-text-opacity: 1;
  color: rgb(0 47 167 / var(--tw-text-opacity, 1));
}
.hover\\:text-dawn-100:hover{
  --tw-text-opacity: 1;
  color: rgb(255 233 214 / var(--tw-text-opacity, 1));
}
.hover\\:text-dawn-300:hover{
  --tw-text-opacity: 1;
  color: rgb(255 195 157 / var(--tw-text-opacity, 1));
}
.hover\\:text-dawn-800:hover{
  --tw-text-opacity: 1;
  color: rgb(168 60 25 / var(--tw-text-opacity, 1));
}
.hover\\:text-emerald-600:hover{
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.hover\\:text-emerald-950:hover{
  --tw-text-opacity: 1;
  color: rgb(2 44 34 / var(--tw-text-opacity, 1));
}
.hover\\:text-foreground:hover{
  color: hsl(var(--foreground));
}
.hover\\:text-ink:hover{
  --tw-text-opacity: 1;
  color: rgb(10 10 11 / var(--tw-text-opacity, 1));
}
.hover\\:text-muted-foreground:hover{
  color: hsl(var(--muted-foreground));
}
.hover\\:text-primary-foreground:hover{
  color: hsl(var(--primary-foreground));
}
.hover\\:text-rose-600:hover{
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}
.hover\\:text-rose-700:hover{
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity, 1));
}
.hover\\:text-stone-700:hover{
  --tw-text-opacity: 1;
  color: rgb(68 64 60 / var(--tw-text-opacity, 1));
}
.hover\\:text-stone-800:hover{
  --tw-text-opacity: 1;
  color: rgb(41 37 36 / var(--tw-text-opacity, 1));
}
.hover\\:text-stone-900:hover{
  --tw-text-opacity: 1;
  color: rgb(28 25 23 / var(--tw-text-opacity, 1));
}
.hover\\:text-stone-950:hover{
  --tw-text-opacity: 1;
  color: rgb(12 10 9 / var(--tw-text-opacity, 1));
}
.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.hover\\:underline:hover{
  text-decoration-line: underline;
}
.hover\\:decoration-dawn-300:hover{
  text-decoration-color: #ffc39d;
}
.hover\\:opacity-100:hover{
  opacity: 1;
}
.hover\\:opacity-80:hover{
  opacity: 0.8;
}
.hover\\:shadow-\\[0_8px_30px_-6px_rgba\\(255\\2c 143\\2c 94\\2c 0\\.45\\)\\]:hover{
  --tw-shadow: 0 8px 30px -6px rgba(255,143,94,0.45);
  --tw-shadow-colored: 0 8px 30px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-lg:hover{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-sm:hover{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:not-sr-only:focus{
  position: static;
  width: auto;
  height: auto;
  padding: 0;
  margin: 0;
  overflow: visible;
  clip: auto;
  white-space: normal;
}
.focus\\:fixed:focus{
  position: fixed;
}
.focus\\:left-3:focus{
  left: 0.75rem;
}
.focus\\:top-3:focus{
  top: 0.75rem;
}
.focus\\:z-50:focus{
  z-index: 50;
}
.focus\\:rounded-sm:focus{
  border-radius: calc(var(--radius) - 4px);
}
.focus\\:border-brand:focus{
  --tw-border-opacity: 1;
  border-color: rgb(0 47 167 / var(--tw-border-opacity, 1));
}
.focus\\:border-dawn-300\\/70:focus{
  border-color: rgb(255 195 157 / 0.7);
}
.focus\\:border-night:focus{
  --tw-border-opacity: 1;
  border-color: rgb(8 11 24 / var(--tw-border-opacity, 1));
}
.focus\\:bg-accent:focus{
  background-color: hsl(var(--accent));
}
.focus\\:bg-night:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(8 11 24 / var(--tw-bg-opacity, 1));
}
.focus\\:bg-primary:focus{
  background-color: hsl(var(--primary));
}
.focus\\:px-4:focus{
  padding-left: 1rem;
  padding-right: 1rem;
}
.focus\\:py-2:focus{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.focus\\:text-accent-foreground:focus{
  color: hsl(var(--accent-foreground));
}
.focus\\:text-primary-foreground:focus{
  color: hsl(var(--primary-foreground));
}
.focus\\:text-white:focus{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.focus\\:opacity-100:focus{
  opacity: 1;
}
.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-1:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-brand:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 47 167 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-brand\\/20:focus{
  --tw-ring-color: rgb(0 47 167 / 0.2);
}
.focus\\:ring-brand\\/30:focus{
  --tw-ring-color: rgb(0 47 167 / 0.3);
}
.focus\\:ring-dawn-500\\/20:focus{
  --tw-ring-color: rgb(255 143 94 / 0.2);
}
.focus\\:ring-ring:focus{
  --tw-ring-color: hsl(var(--ring));
}
.focus\\:ring-offset-2:focus{
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-visible\\:ring-1:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-night-lift:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 19 38 / var(--tw-ring-opacity, 1));
}
.focus-visible\\:ring-ring:focus-visible{
  --tw-ring-color: hsl(var(--ring));
}
.focus-visible\\:ring-offset-1:focus-visible{
  --tw-ring-offset-width: 1px;
}
.focus-visible\\:ring-offset-2:focus-visible{
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:ring-offset-background:focus-visible{
  --tw-ring-offset-color: hsl(var(--background));
}
.active\\:cursor-grabbing:active{
  cursor: grabbing;
}
.disabled\\:pointer-events-none:disabled{
  pointer-events: none;
}
.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}
.disabled\\:text-stone-300:disabled{
  --tw-text-opacity: 1;
  color: rgb(214 211 209 / var(--tw-text-opacity, 1));
}
.disabled\\:opacity-30:disabled{
  opacity: 0.3;
}
.disabled\\:opacity-40:disabled{
  opacity: 0.4;
}
.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}
.disabled\\:opacity-60:disabled{
  opacity: 0.6;
}
.disabled\\:hover\\:border-sand:hover:disabled{
  --tw-border-opacity: 1;
  border-color: rgb(228 219 204 / var(--tw-border-opacity, 1));
}
.disabled\\:hover\\:text-stone-500:hover:disabled{
  --tw-text-opacity: 1;
  color: rgb(120 113 108 / var(--tw-text-opacity, 1));
}
.group:focus-within .group-focus-within\\:block{
  display: block;
}
.group\\/prose:focus-within .group-focus-within\\/prose\\:opacity-100{
  opacity: 1;
}
.group:hover .group-hover\\:translate-x-0{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:translate-x-0\\.5{
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-105{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:border-stone-400{
  --tw-border-opacity: 1;
  border-color: rgb(168 162 158 / var(--tw-border-opacity, 1));
}
.group:hover .group-hover\\:bg-dawn-500{
  --tw-bg-opacity: 1;
  background-color: rgb(255 143 94 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-night{
  --tw-bg-opacity: 1;
  background-color: rgb(8 11 24 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-stone-400{
  --tw-bg-opacity: 1;
  background-color: rgb(168 162 158 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-stone-500{
  --tw-bg-opacity: 1;
  background-color: rgb(120 113 108 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:text-brand{
  --tw-text-opacity: 1;
  color: rgb(0 47 167 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-dawn-300{
  --tw-text-opacity: 1;
  color: rgb(255 195 157 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-dawn-800{
  --tw-text-opacity: 1;
  color: rgb(168 60 25 / var(--tw-text-opacity, 1));
}
.group\\/prose:hover .group-hover\\/prose\\:opacity-100{
  opacity: 1;
}
.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}
.group:focus-visible .group-focus-visible\\:border-dawn-700{
  --tw-border-opacity: 1;
  border-color: rgb(217 83 31 / var(--tw-border-opacity, 1));
}
.group:focus-visible .group-focus-visible\\:bg-dawn-700{
  --tw-bg-opacity: 1;
  background-color: rgb(217 83 31 / var(--tw-bg-opacity, 1));
}
.group:focus-visible .group-focus-visible\\:opacity-100{
  opacity: 1;
}
.group.destructive .group-\\[\\.destructive\\]\\:border-muted\\/40{
  border-color: hsl(var(--muted) / 0.4);
}
.group.destructive .group-\\[\\.destructive\\]\\:text-red-300{
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:border-destructive\\/30:hover{
  border-color: hsl(var(--destructive) / 0.3);
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:bg-destructive:hover{
  background-color: hsl(var(--destructive));
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-destructive-foreground:hover{
  color: hsl(var(--destructive-foreground));
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-red-50:hover{
  --tw-text-opacity: 1;
  color: rgb(254 242 242 / var(--tw-text-opacity, 1));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-destructive:focus{
  --tw-ring-color: hsl(var(--destructive));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-red-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 113 113 / var(--tw-ring-opacity, 1));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-offset-red-600:focus{
  --tw-ring-offset-color: #dc2626;
}
.peer:disabled ~ .peer-disabled\\:cursor-not-allowed{
  cursor: not-allowed;
}
.peer:disabled ~ .peer-disabled\\:opacity-70{
  opacity: 0.7;
}
.has-\\[\\:disabled\\]\\:opacity-50:has(:disabled){
  opacity: 0.5;
}
.aria-selected\\:bg-accent[aria-selected="true"]{
  background-color: hsl(var(--accent));
}
.aria-selected\\:bg-accent\\/50[aria-selected="true"]{
  background-color: hsl(var(--accent) / 0.5);
}
.aria-selected\\:text-accent-foreground[aria-selected="true"]{
  color: hsl(var(--accent-foreground));
}
.aria-selected\\:text-muted-foreground[aria-selected="true"]{
  color: hsl(var(--muted-foreground));
}
.aria-selected\\:opacity-100[aria-selected="true"]{
  opacity: 1;
}
.data-\\[disabled\\=true\\]\\:pointer-events-none[data-disabled="true"]{
  pointer-events: none;
}
.data-\\[disabled\\]\\:pointer-events-none[data-disabled]{
  pointer-events: none;
}
.data-\\[panel-group-direction\\=vertical\\]\\:h-px[data-panel-group-direction="vertical"]{
  height: 1px;
}
.data-\\[panel-group-direction\\=vertical\\]\\:w-full[data-panel-group-direction="vertical"]{
  width: 100%;
}
.data-\\[side\\=bottom\\]\\:translate-y-1[data-side="bottom"]{
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=left\\]\\:-translate-x-1[data-side="left"]{
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=right\\]\\:translate-x-1[data-side="right"]{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=top\\]\\:-translate-y-1[data-side="top"]{
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=checked\\]\\:translate-x-4[data-state="checked"]{
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=unchecked\\]\\:translate-x-0[data-state="unchecked"]{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=cancel\\]\\:translate-x-0[data-swipe="cancel"]{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=end\\]\\:translate-x-\\[var\\(--radix-toast-swipe-end-x\\)\\][data-swipe="end"]{
  --tw-translate-x: var(--radix-toast-swipe-end-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=move\\]\\:translate-x-\\[var\\(--radix-toast-swipe-move-x\\)\\][data-swipe="move"]{
  --tw-translate-x: var(--radix-toast-swipe-move-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes accordion-up{

  from{
    height: var(--radix-accordion-content-height);
  }

  to{
    height: 0;
  }
}
.data-\\[state\\=closed\\]\\:animate-accordion-up[data-state="closed"]{
  animation: accordion-up 0.2s ease-out;
}
@keyframes accordion-down{

  from{
    height: 0;
  }

  to{
    height: var(--radix-accordion-content-height);
  }
}
.data-\\[state\\=open\\]\\:animate-accordion-down[data-state="open"]{
  animation: accordion-down 0.2s ease-out;
}
.data-\\[panel-group-direction\\=vertical\\]\\:flex-col[data-panel-group-direction="vertical"]{
  flex-direction: column;
}
.data-\\[drag-over\\=true\\]\\:border-brand[data-drag-over="true"]{
  --tw-border-opacity: 1;
  border-color: rgb(0 47 167 / var(--tw-border-opacity, 1));
}
.data-\\[selected\\=true\\]\\:bg-accent[data-selected="true"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=active\\]\\:bg-background[data-state="active"]{
  background-color: hsl(var(--background));
}
.data-\\[state\\=active\\]\\:bg-white[data-state="active"]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.data-\\[state\\=checked\\]\\:bg-primary[data-state="checked"]{
  background-color: hsl(var(--primary));
}
.data-\\[state\\=on\\]\\:bg-accent[data-state="on"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:bg-accent[data-state="open"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:bg-accent\\/50[data-state="open"]{
  background-color: hsl(var(--accent) / 0.5);
}
.data-\\[state\\=open\\]\\:bg-secondary[data-state="open"]{
  background-color: hsl(var(--secondary));
}
.data-\\[state\\=selected\\]\\:bg-muted[data-state="selected"]{
  background-color: hsl(var(--muted));
}
.data-\\[state\\=unchecked\\]\\:bg-input[data-state="unchecked"]{
  background-color: hsl(var(--input));
}
.data-\\[placeholder\\]\\:text-muted-foreground[data-placeholder]{
  color: hsl(var(--muted-foreground));
}
.data-\\[selected\\=true\\]\\:text-accent-foreground[data-selected="true"]{
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=active\\]\\:text-foreground[data-state="active"]{
  color: hsl(var(--foreground));
}
.data-\\[state\\=checked\\]\\:text-primary-foreground[data-state="checked"]{
  color: hsl(var(--primary-foreground));
}
.data-\\[state\\=on\\]\\:text-accent-foreground[data-state="on"]{
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=open\\]\\:text-accent-foreground[data-state="open"]{
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=open\\]\\:text-muted-foreground[data-state="open"]{
  color: hsl(var(--muted-foreground));
}
.data-\\[disabled\\=true\\]\\:opacity-50[data-disabled="true"]{
  opacity: 0.5;
}
.data-\\[disabled\\]\\:opacity-50[data-disabled]{
  opacity: 0.5;
}
.data-\\[dragging\\=true\\]\\:opacity-50[data-dragging="true"]{
  opacity: 0.5;
}
.data-\\[state\\=active\\]\\:shadow[data-state="active"]{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[state\\=active\\]\\:shadow-none[data-state="active"]{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[drag-over\\=true\\]\\:ring-1[data-drag-over="true"]{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.data-\\[drag-over\\=true\\]\\:ring-brand[data-drag-over="true"]{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 47 167 / var(--tw-ring-opacity, 1));
}
.data-\\[swipe\\=move\\]\\:transition-none[data-swipe="move"]{
  transition-property: none;
}
.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  transition-duration: 300ms;
}
.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  transition-duration: 500ms;
}
.data-\\[motion\\^\\=from-\\]\\:animate-in[data-motion^="from-"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=open\\]\\:animate-in[data-state="open"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=visible\\]\\:animate-in[data-state="visible"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[motion\\^\\=to-\\]\\:animate-out[data-motion^="to-"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[state\\=closed\\]\\:animate-out[data-state="closed"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[state\\=hidden\\]\\:animate-out[data-state="hidden"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[swipe\\=end\\]\\:animate-out[data-swipe="end"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[motion\\^\\=from-\\]\\:fade-in[data-motion^="from-"]{
  --tw-enter-opacity: 0;
}
.data-\\[motion\\^\\=to-\\]\\:fade-out[data-motion^="to-"]{
  --tw-exit-opacity: 0;
}
.data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"]{
  --tw-exit-opacity: 0;
}
.data-\\[state\\=closed\\]\\:fade-out-80[data-state="closed"]{
  --tw-exit-opacity: 0.8;
}
.data-\\[state\\=hidden\\]\\:fade-out[data-state="hidden"]{
  --tw-exit-opacity: 0;
}
.data-\\[state\\=open\\]\\:fade-in-0[data-state="open"]{
  --tw-enter-opacity: 0;
}
.data-\\[state\\=visible\\]\\:fade-in[data-state="visible"]{
  --tw-enter-opacity: 0;
}
.data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"]{
  --tw-exit-scale: .95;
}
.data-\\[state\\=open\\]\\:zoom-in-90[data-state="open"]{
  --tw-enter-scale: .9;
}
.data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"]{
  --tw-enter-scale: .95;
}
.data-\\[motion\\=from-end\\]\\:slide-in-from-right-52[data-motion="from-end"]{
  --tw-enter-translate-x: 13rem;
}
.data-\\[motion\\=from-start\\]\\:slide-in-from-left-52[data-motion="from-start"]{
  --tw-enter-translate-x: -13rem;
}
.data-\\[motion\\=to-end\\]\\:slide-out-to-right-52[data-motion="to-end"]{
  --tw-exit-translate-x: 13rem;
}
.data-\\[motion\\=to-start\\]\\:slide-out-to-left-52[data-motion="to-start"]{
  --tw-exit-translate-x: -13rem;
}
.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side="bottom"]{
  --tw-enter-translate-y: -0.5rem;
}
.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side="left"]{
  --tw-enter-translate-x: 0.5rem;
}
.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side="right"]{
  --tw-enter-translate-x: -0.5rem;
}
.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side="top"]{
  --tw-enter-translate-y: 0.5rem;
}
.data-\\[state\\=closed\\]\\:slide-out-to-bottom[data-state="closed"]{
  --tw-exit-translate-y: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-left[data-state="closed"]{
  --tw-exit-translate-x: -100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2[data-state="closed"]{
  --tw-exit-translate-x: -50%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-right[data-state="closed"]{
  --tw-exit-translate-x: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-right-full[data-state="closed"]{
  --tw-exit-translate-x: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-top[data-state="closed"]{
  --tw-exit-translate-y: -100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\][data-state="closed"]{
  --tw-exit-translate-y: -48%;
}
.data-\\[state\\=open\\]\\:slide-in-from-bottom[data-state="open"]{
  --tw-enter-translate-y: 100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-left[data-state="open"]{
  --tw-enter-translate-x: -100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2[data-state="open"]{
  --tw-enter-translate-x: -50%;
}
.data-\\[state\\=open\\]\\:slide-in-from-right[data-state="open"]{
  --tw-enter-translate-x: 100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top[data-state="open"]{
  --tw-enter-translate-y: -100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\][data-state="open"]{
  --tw-enter-translate-y: -48%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top-full[data-state="open"]{
  --tw-enter-translate-y: -100%;
}
.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  animation-duration: 300ms;
}
.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  animation-duration: 500ms;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:left-0[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  left: 0px;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:h-1[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  height: 0.25rem;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:w-full[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  width: 100%;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:-translate-y-1\\/2[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:translate-x-0[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=open\\]\\:hover\\:bg-accent:hover[data-state="open"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:focus\\:bg-accent:focus[data-state="open"]{
  background-color: hsl(var(--accent));
}
.group[data-state="open"] .group-data-\\[state\\=open\\]\\:rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@media (prefers-reduced-motion: no-preference){

  .motion-safe\\:animate-\\[horizonsweep_1\\.6s_ease-out_1\\]{
    animation: horizonsweep 1.6s ease-out 1;
  }

  .motion-safe\\:animate-\\[truthdrift_9s_ease-in-out_infinite\\]{
    animation: truthdrift 9s ease-in-out infinite;
  }

  @keyframes ascentdrift{

    0%, 100%{
      transform: rotateY(0deg) rotateX(0deg) translateY(0);
    }

    50%{
      transform: rotateY(2.2deg) rotateX(-1deg) translateY(-8px);
    }
  }

  .motion-safe\\:animate-ascentdrift{
    animation: ascentdrift 14s ease-in-out infinite;
  }

  @keyframes daybreak{

    0%, 100%{
      opacity: 0.82;
      transform: translateY(0);
    }

    50%{
      opacity: 1;
      transform: translateY(-1.5%);
    }
  }

  .motion-safe\\:animate-daybreak{
    animation: daybreak 12s ease-in-out infinite;
  }

  .motion-safe\\:opacity-100{
    opacity: 1;
  }

  .motion-safe\\:transition-\\[transform\\2c opacity\\]{
    transition-property: transform,opacity;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
  }

  .motion-safe\\:duration-500{
    transition-duration: 500ms;
  }

  .motion-safe\\:ease-out{
    transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }

  .motion-safe\\:duration-500{
    animation-duration: 500ms;
  }

  .motion-safe\\:ease-out{
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
}
.dark\\:border-destructive:is(.dark *){
  border-color: hsl(var(--destructive));
}
@media (min-width: 640px){

  .sm\\:bottom-0{
    bottom: 0px;
  }

  .sm\\:right-0{
    right: 0px;
  }

  .sm\\:top-auto{
    top: auto;
  }

  .sm\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .sm\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .sm\\:mt-0{
    margin-top: 0px;
  }

  .sm\\:block{
    display: block;
  }

  .sm\\:inline{
    display: inline;
  }

  .sm\\:hidden{
    display: none;
  }

  .sm\\:min-h-\\[64px\\]{
    min-height: 64px;
  }

  .sm\\:w-16{
    width: 4rem;
  }

  .sm\\:w-auto{
    width: auto;
  }

  .sm\\:max-w-lg{
    max-width: 32rem;
  }

  .sm\\:max-w-sm{
    max-width: 24rem;
  }

  .sm\\:max-w-xl{
    max-width: 36rem;
  }

  .sm\\:scale-\\[0\\.86\\]{
    --tw-scale-x: 0.86;
    --tw-scale-y: 0.86;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .sm\\:grid-cols-\\[10rem_1fr\\]{
    grid-template-columns: 10rem 1fr;
  }

  .sm\\:flex-row{
    flex-direction: row;
  }

  .sm\\:flex-col{
    flex-direction: column;
  }

  .sm\\:flex-wrap{
    flex-wrap: wrap;
  }

  .sm\\:items-start{
    align-items: flex-start;
  }

  .sm\\:items-center{
    align-items: center;
  }

  .sm\\:justify-end{
    justify-content: flex-end;
  }

  .sm\\:justify-between{
    justify-content: space-between;
  }

  .sm\\:gap-2\\.5{
    gap: 0.625rem;
  }

  .sm\\:gap-x-7{
    column-gap: 1.75rem;
  }

  .sm\\:gap-y-2{
    row-gap: 0.5rem;
  }

  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .sm\\:rounded-lg{
    border-radius: var(--radius);
  }

  .sm\\:p-12{
    padding: 3rem;
  }

  .sm\\:p-4{
    padding: 1rem;
  }

  .sm\\:p-8{
    padding: 2rem;
  }

  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .sm\\:text-left{
    text-align: left;
  }

  .sm\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .sm\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }

  .sm\\:text-6xl{
    font-size: 3.75rem;
    line-height: 1;
  }

  .sm\\:text-\\[15px\\]{
    font-size: 15px;
  }

  .data-\\[state\\=open\\]\\:sm\\:slide-in-from-bottom-full[data-state="open"]{
    --tw-enter-translate-y: 100%;
  }
}
@media (min-width: 768px){

  .md\\:absolute{
    position: absolute;
  }

  .md\\:top-0{
    top: 0px;
  }

  .md\\:-mx-10{
    margin-left: -2.5rem;
    margin-right: -2.5rem;
  }

  .md\\:block{
    display: block;
  }

  .md\\:flex{
    display: flex;
  }

  .md\\:hidden{
    display: none;
  }

  .md\\:w-\\[var\\(--radix-navigation-menu-viewport-width\\)\\]{
    width: var(--radix-navigation-menu-viewport-width);
  }

  .md\\:w-auto{
    width: auto;
  }

  .md\\:max-w-\\[420px\\]{
    max-width: 420px;
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-cols-\\[200px_1fr\\]{
    grid-template-columns: 200px 1fr;
  }

  .md\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
@media (min-width: 1024px){

  .lg\\:sticky{
    position: sticky;
  }

  .lg\\:top-24{
    top: 6rem;
  }

  .lg\\:top-6{
    top: 1.5rem;
  }

  .lg\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .lg\\:col-span-3{
    grid-column: span 3 / span 3;
  }

  .lg\\:col-span-4{
    grid-column: span 4 / span 4;
  }

  .lg\\:col-span-5{
    grid-column: span 5 / span 5;
  }

  .lg\\:col-span-6{
    grid-column: span 6 / span 6;
  }

  .lg\\:col-span-7{
    grid-column: span 7 / span 7;
  }

  .lg\\:col-span-8{
    grid-column: span 8 / span 8;
  }

  .lg\\:col-start-8{
    grid-column-start: 8;
  }

  .lg\\:mt-12{
    margin-top: 3rem;
  }

  .lg\\:block{
    display: block;
  }

  .lg\\:flex{
    display: flex;
  }

  .lg\\:hidden{
    display: none;
  }

  .lg\\:scale-100{
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .lg\\:grid-flow-row-dense{
    grid-auto-flow: row dense;
  }

  .lg\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-7{
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .lg\\:grid-cols-\\[15rem_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: 15rem minmax(0,1fr);
  }

  .lg\\:grid-cols-\\[1fr_auto\\]{
    grid-template-columns: 1fr auto;
  }

  .lg\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_clamp\\(320px\\2c var\\(--preview-w\\)\\2c 55\\%\\)\\]{
    grid-template-columns: minmax(0,1fr) clamp(320px,var(--preview-w),55%);
  }

  .lg\\:items-start{
    align-items: flex-start;
  }

  .lg\\:gap-10{
    gap: 2.5rem;
  }

  .lg\\:gap-12{
    gap: 3rem;
  }

  .lg\\:gap-14{
    gap: 3.5rem;
  }

  .lg\\:gap-16{
    gap: 4rem;
  }

  .lg\\:gap-x-7{
    column-gap: 1.75rem;
  }

  .lg\\:self-start{
    align-self: flex-start;
  }

  .lg\\:py-12{
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .lg\\:py-14{
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }

  .lg\\:py-16{
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .lg\\:py-20{
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .lg\\:pb-16{
    padding-bottom: 4rem;
  }

  .lg\\:pt-12{
    padding-top: 3rem;
  }

  .lg\\:pt-24{
    padding-top: 6rem;
  }

  .lg\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .lg\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .lg\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .lg\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }

  .lg\\:text-6xl{
    font-size: 3.75rem;
    line-height: 1;
  }

  .lg\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}
@media (min-width: 1280px){

  .xl\\:sticky{
    position: sticky;
  }

  .xl\\:-left-\\[18px\\]{
    left: -18px;
  }

  .xl\\:top-6{
    top: 1.5rem;
  }

  .xl\\:block{
    display: block;
  }

  .xl\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .xl\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .xl\\:grid-cols-\\[152px_minmax\\(0\\2c 1fr\\)_clamp\\(320px\\2c var\\(--preview-w\\)\\2c 55\\%\\)\\]{
    grid-template-columns: 152px minmax(0,1fr) clamp(320px,var(--preview-w),55%);
  }

  .xl\\:grid-cols-\\[15rem_minmax\\(0\\2c 1fr\\)_minmax\\(0\\2c 1\\.05fr\\)\\]{
    grid-template-columns: 15rem minmax(0,1fr) minmax(0,1.05fr);
  }

  .xl\\:gap-6{
    gap: 1.5rem;
  }

  .xl\\:self-start{
    align-self: flex-start;
  }

  .xl\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }
}
@media (min-width: 1536px){

  .\\32xl\\:inline{
    display: inline;
  }
}
.\\[\\&\\+div\\]\\:text-xs+div{
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\[\\&\\:\\:-webkit-scrollbar\\]\\:hidden::-webkit-scrollbar{
  display: none;
}
.\\[\\&\\:has\\(\\>\\.day-range-end\\)\\]\\:rounded-r-md:has(>.day-range-end){
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\>\\.day-range-start\\)\\]\\:rounded-l-md:has(>.day-range-start){
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-md:has([aria-selected]){
  border-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:bg-accent:has([aria-selected]){
  background-color: hsl(var(--accent));
}
.first\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-l-md:has([aria-selected]):first-child{
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.last\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-r-md:has([aria-selected]):last-child{
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-outside\\)\\]\\:bg-accent\\/50:has([aria-selected].day-outside){
  background-color: hsl(var(--accent) / 0.5);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-range-end\\)\\]\\:rounded-r-md:has([aria-selected].day-range-end){
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0:has([role=checkbox]){
  padding-right: 0px;
}
.\\[\\&\\>\\[role\\=checkbox\\]\\]\\:translate-y-\\[2px\\]>[role=checkbox]{
  --tw-translate-y: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\>span\\]\\:line-clamp-1>span{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.\\[\\&\\>svg\\+div\\]\\:translate-y-\\[-3px\\]>svg+div{
  --tw-translate-y: -3px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\>svg\\]\\:absolute>svg{
  position: absolute;
}
.\\[\\&\\>svg\\]\\:left-4>svg{
  left: 1rem;
}
.\\[\\&\\>svg\\]\\:top-4>svg{
  top: 1rem;
}
.\\[\\&\\>svg\\]\\:size-4>svg{
  width: 1rem;
  height: 1rem;
}
.\\[\\&\\>svg\\]\\:h-3\\.5>svg{
  height: 0.875rem;
}
.\\[\\&\\>svg\\]\\:w-3\\.5>svg{
  width: 0.875rem;
}
.\\[\\&\\>svg\\]\\:shrink-0>svg{
  flex-shrink: 0;
}
.\\[\\&\\>svg\\]\\:text-destructive>svg{
  color: hsl(var(--destructive));
}
.\\[\\&\\>svg\\]\\:text-foreground>svg{
  color: hsl(var(--foreground));
}
.\\[\\&\\>svg\\~\\*\\]\\:pl-7>svg~*{
  padding-left: 1.75rem;
}
.\\[\\&\\>tr\\]\\:last\\:border-b-0:last-child>tr{
  border-bottom-width: 0px;
}
.\\[\\&\\[data-panel-group-direction\\=vertical\\]\\>div\\]\\:rotate-90[data-panel-group-direction=vertical]>div{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:rotate-180[data-state=open]>svg{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-2 [cmdk-group-heading]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:py-1\\.5 [cmdk-group-heading]{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-xs [cmdk-group-heading]{
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium [cmdk-group-heading]{
  font-weight: 500;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-muted-foreground [cmdk-group-heading]{
  color: hsl(var(--muted-foreground));
}
.\\[\\&_\\[cmdk-group\\]\\:not\\(\\[hidden\\]\\)_\\~\\[cmdk-group\\]\\]\\:pt-0 [cmdk-group]:not([hidden]) ~[cmdk-group]{
  padding-top: 0px;
}
.\\[\\&_\\[cmdk-group\\]\\]\\:px-2 [cmdk-group]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:h-5 [cmdk-input-wrapper] svg{
  height: 1.25rem;
}
.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:w-5 [cmdk-input-wrapper] svg{
  width: 1.25rem;
}
.\\[\\&_\\[cmdk-input\\]\\]\\:h-12 [cmdk-input]{
  height: 3rem;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:px-2 [cmdk-item]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:py-3 [cmdk-item]{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:h-5 [cmdk-item] svg{
  height: 1.25rem;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:w-5 [cmdk-item] svg{
  width: 1.25rem;
}
.\\[\\&_li\\]\\:text-stone-700 li{
  --tw-text-opacity: 1;
  color: rgb(68 64 60 / var(--tw-text-opacity, 1));
}
.\\[\\&_p\\]\\:leading-relaxed p{
  line-height: 1.625;
}
.\\[\\&_svg\\]\\:pointer-events-none svg{
  pointer-events: none;
}
.\\[\\&_svg\\]\\:size-4 svg{
  width: 1rem;
  height: 1rem;
}
.\\[\\&_svg\\]\\:shrink-0 svg{
  flex-shrink: 0;
}
.\\[\\&_tr\\:last-child\\]\\:border-0 tr:last-child{
  border-width: 0px;
}
.\\[\\&_tr\\]\\:border-b tr{
  border-bottom-width: 1px;
}
.\\[\\&_ul\\]\\:list-disc ul{
  list-style-type: disc;
}
.\\[\\&_ul\\]\\:space-y-1 ul > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.\\[\\&_ul\\]\\:pl-5 ul{
  padding-left: 1.25rem;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,sEAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;;;;;;;;;+BAAc;;AAAd;IAAA,wBAAc,OAAd,uBAAc;IAAd,wBAAc,OAAd,oBAAc;IAAd,iBAAc,cAAd,kDAAc;IAAd,6BAAc;IAAd,oBAAc;IAAd,gCAAc;IAAd,uBAAc,QAAd,iDAAc;IAAd,+BAAc;IAAd,uBAAc;IAAd,kCAAc;IAAd,mBAAc;IAAd,6BAAc;IAAd,oBAAc;IAAd,+BAAc;IAAd,0BAAc;IAAd,kCAAc;IAAd,oBAAc,WAAd,SAAc;IAAd,mBAAc;IAAd,kBAAc,aAAd,8CAAc;IAAd,uBAAc;IAAd,sBAAc;IAAd,sBAAc,SAAd,+CAAc;IAAd,sBAAc;IAAd,oBAAc;IAAd,iBAAc;;IAAd;;sEAAc;IAAd,0CAAc;IAAd,wCAAc;IAAd,uCAAc;IAAd,iBAAc;IAAd,wBAAc;IAAd,iBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd,4BAAc;IAAd,2BAAc;IAAd,uBAAc;IAAd,uBAAc;IAAd,oBAAc;;IAAd,qEAAc;IAAd,sBAAc;IAAd,oBAAc;IAAd,+CAAc;IAAd,uDAAc;IAAd,qDAAc;IAAd,WAAc;IAAd,eAAc;EAAA;;AAAd;;;;;;;;;;;;8EAAc;;AAAd;;IAAA,wBAAc;IAAd,uBAAc;IAAd,mBAAc;IAAd,4BAAc;IAAd,sBAAc;IAAd,+BAAc;IAAd,wBAAc;IAAd,iCAAc;IAAd,oBAAc;IAAd,+BAAc;IAAd,qBAAc,UAAd,aAAc;IAAd,+BAAc;IAAd,qBAAc;IAAd,oBAAc;IAAd,mBAAc;IAAd,0BAAc;IAAd,oCAAc;EAAA;;AAAd;EAAA;AAAc;;AAAd;EAAA,wCAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA,YAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA,wBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uEAAmB;EAAnB,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4EAAmB;EAAnB,6FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,0GAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mCAAmB;IAAnB;EAAmB;AAAA;AAAnB;;EAAA;IAAA,kCAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA,qBAAmB;EAAnB,yBAAmB;EAAnB,2BAAmB;EAAnB,yBAAmB;EAAnB,0BAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;EACE,uEAAuE;EACvE,4DAA4D;EAC5D,uDAAuD;EACvD,kDAAkD;EAClD,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB;mEACiE;EACjE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB;;4EAE0E;EAC1E,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B;;0BAEwB;EACxB,oBAAoB;EACpB,yCAAyC;EACzC,kCAAkC;EAClC;2CACyC;EACzC,iBAAiB;EACjB,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;kFAEkF;AAClF;EACE,+CAA+C;EAC/C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;yDAGyD;AACzD;EACE;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;IACtC,gCAAgC;EAClC;AACF;;AAgHA,6CAA6C;AAC7C;EACE;wDACsD;EACtD,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,qCAAqC;EACrC,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,gBAAgB,gCAAgC,EAAE;AAClD,aAAa,6BAA6B,EAAE;;AAE5C;;;6EAG6E;AAC7E;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,OAAO,sBAAsB,EAAE;AACjC;AACA,gBAAgB,gCAAgC,EAAE;;AAElD,2BAA2B;AAC3B;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;AACA,WAAW,qCAAqC,EAAE;;AAElD,2BAA2B;AAC3B;;;iCAGiC;;AAEjC,oBAAoB;AACpB,sBAAsB,WAAW,EAAE,YAAY,EAAE;AACjD,4BAA4B,mBAAmB,EAAE;AACjD,kCAAkC,mBAAmB,EAAE;AACvD,4BAA4B,mBAAmB,EAAE;;;AAGjD;;2DAE2D;AAC3D;;;mBAGmB;AACnB;EACE,OAAO,4BAA4B,EAAE;EACrC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE,WAAW,qCAAqC,EAAE;EAClD,WAAW,4CAA4C,EAAE;AAC3D;;AAEA;;;;mDAImD;AACnD,iBAAiB,6BAA6B,EAAE;AAChD,8BAA8B,wBAAwB,EAAE;;AAExD;;;;;;;;;;;;;+EAa+E;AAC/E,QAAQ,kBAAkB,EAAE;AAC5B,yBAAyB,yBAAyB,EAAE,IAAI,8BAA8B;AACtF,yBAAyB,yBAAyB,EAAE,IAAI,8BAA8B;AACtF,yBAAyB,yBAAyB,EAAE,IAAI,8BAA8B;AACtF,yBAAyB,yBAAyB,EAAE,IAAI,8BAA8B;AACtF,yBAAyB,yBAAyB,EAAE;AACpD,yBAAyB,2CAA2C,EAAE;AACtE;yBACyB,2CAA2C,EAAE;AACtE;0BAC0B,uCAAuC,EAAE;AACnE,2BAA2B,uCAAuC,EAAE;AACpE,yBAAyB,sCAAsC,EAAE,IAAI,qCAAqC;AAC1G;yBACyB,cAAc,EAAE;AACzC,yBAAyB,gCAAgC,EAAE;AAC3D,yBAAyB,gCAAgC,EAAE;AAC3D,yBAAyB,gCAAgC,EAAE,SAAS,mBAAmB;AACvF;kCACkC,2CAA2C,EAAE;AAC/E;;kCAEkC,2CAA2C,EAAE;AAC/E;qCACqC,cAAc,EAAE;AACrD,yBAAyB,yBAAyB,EAAE,IAAI,sCAAsC;AAC9F,qCAAqC,yBAAyB,EAAE;AAChE,yBAAyB,cAAc,EAAE;AACzC,iCAAiC,cAAc,EAAE;AACjD,yCAAyC,gBAAgB,EAAE;AAC3D,kDAAkD;AAClD,yBAAyB,0CAA0C,EAAE;AACrE,0BAA0B,cAAc,EAAE;AAC1C,4BAA4B,uCAAuC,EAAE;AACrE,yBAAyB,0CAA0C,EAAE;AACrE,yBAAyB,cAAc,EAAE;AACzC,0BAA0B,sCAAsC,EAAE;AAClE,yBAAyB,0CAA0C,EAAE;AACrE,yBAAyB,cAAc,EAAE;AACzC,yBAAyB,uCAAuC,EAAE;AAClE;yBACyB,yCAAyC,EAAE;AACpE,yBAAyB,cAAc,EAAE;AACzC;yBACyB,uCAAuC,EAAE;AAClE,kCAAkC,wCAAwC,EAAE;;AAE5E;sEACsE;AACtE;;;wBAGwB,uCAAuC,EAAE;AACjE,2BAA2B,sCAAsC,EAAE;AACnE;;wBAEwB,wCAAwC,EAAE;AAClE;;wBAEwB,2CAA2C,EAAE;AACrE,yBAAyB,uCAAuC,EAAE;AAClE,qEAAqE;AACrE;kCACkC,0CAA0C,EAAE;AAC9E,6DAA6D;AAC7D,+DAA+D,yBAAyB,EAAE;AAC1F,gCAAgC;AAChC,yBAAyB,+BAA+B,EAAE;AAC1D,yBAAyB,gCAAgC,EAAE;AAC3D,yBAAyB,gCAAgC,EAAE;AAC3D,yBAAyB,gCAAgC,EAAE;AAC3D,qCAAqC,+BAA+B,EAAE;AACtE;;uCAEuC,sCAAsC,EAAE;AAC/E,kDAAkD,+BAA+B,EAAE;AACnF;;sDAEsD;AACtD,mFAAmF,6BAA6B,EAAE;;AAElH;;2DAE2D;AAC3D;EACE,8DAA8D;EAC9D,2DAA2D;EAC3D,wCAAwC;AAC1C;AACA;EACE,6DAA6D;EAC7D,0DAA0D;EAC1D,wCAAwC;AAC1C;AACA;EACE,+EAA+E;EAC/E,4EAA4E;EAC5E,wCAAwC;AAC1C;;AAEA;;6DAE6D;AAC7D,wBAAwB,kBAAkB,EAAE;AAC5C,wBAAwB,kBAAkB,EAAE;AAC5C,wBAAwB,cAAc,EAAE;AAtYxC;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,mBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,0BAuYA;EAvYA;AAuYA;AAvYA;EAAA,0BAuYA;EAvYA,QAuYA;EAvYA;AAuYA;AAvYA;EAAA,0BAuYA;EAvYA;AAuYA;AAvYA;EAAA,0BAuYA;EAvYA;AAuYA;AAvYA;EAAA,0BAuYA;EAvYA,sBAuYA;EAvYA;AAuYA;AAvYA;EAAA,iDAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,kDAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,2GAuYA;EAvYA,yGAuYA;EAvYA;AAuYA;AAvYA;EAAA,2GAuYA;EAvYA,yGAuYA;EAvYA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,2BAuYA;EAvYA;AAuYA;AAvYA;EAAA,sBAuYA;EAvYA;AAuYA;AAvYA;EAAA,sBAuYA;EAvYA;AAuYA;AAvYA;EAAA,sBAuYA;EAvYA;AAuYA;AAvYA;EAAA,sBAuYA;EAvYA;AAuYA;AAvYA;EAAA,kBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,kBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,kBAuYA;EAvYA;AAuYA;AAvYA;EAAA,kBAuYA;EAvYA;AAuYA;AAvYA;EAAA,kBAuYA;EAvYA;AAuYA;AAvYA;EAAA,kBAuYA;EAvYA;AAuYA;AAvYA;EAAA,kBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,kBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,kBAuYA;EAvYA;AAuYA;AAvYA;EAAA,kBAuYA;EAvYA;AAuYA;AAvYA;EAAA,kBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,kBAuYA;EAvYA;AAuYA;AAvYA;EAAA,kBAuYA;EAvYA;AAuYA;AAvYA;EAAA,kBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,kBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,kDAuYA;EAvYA,2DAuYA;EAvYA;AAuYA;AAvYA;EAAA,+EAuYA;EAvYA,mGAuYA;EAvYA;AAuYA;AAvYA;EAAA,0CAuYA;EAvYA,uDAuYA;EAvYA;AAuYA;AAvYA;EAAA,gBAuYA;EAvYA,WAuYA;EAvYA,YAuYA;EAvYA,UAuYA;EAvYA,SAuYA;EAvYA,iBAuYA;EAvYA,UAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,sBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,sBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,kBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,kBAuYA;EAvYA;AAuYA;AAvYA;EAAA,mBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,8BAuYA;EAvYA;AAuYA;AAvYA;EAAA,2GAuYA;EAvYA,yGAuYA;EAvYA;AAuYA;AAvYA;EAAA,2GAuYA;EAvYA,yGAuYA;EAvYA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,8BAuYA;EAvYA;AAuYA;AAvYA;EAAA,2GAuYA;EAvYA,yGAuYA;EAvYA;AAuYA;AAvYA;EAAA,2GAuYA;EAvYA,yGAuYA;EAvYA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,sBAuYA;EAvYA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,qBAuYA;EAvYA;AAuYA;AAvYA;EAAA,0BAuYA;EAvYA;AAuYA;AAvYA;EAAA,kBAuYA;EAvYA,kBAuYA;EAvYA;AAuYA;AAvYA;EAAA,sBAuYA;EAvYA;AAuYA;AAvYA;EAAA,kBAuYA;EAvYA;AAuYA;AAvYA;EAAA,kBAuYA;EAvYA;AAuYA;AAvYA;EAAA,kBAuYA;EAvYA;AAuYA;AAvYA;EAAA,kBAuYA;EAvYA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,sBAuYA;EAvYA;AAuYA;AAvYA;EAAA,kBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,yBAuYA;EAvYA;AAuYA;AAvYA;EAAA,0BAuYA;EAvYA;AAuYA;AAvYA;EAAA,yBAuYA;EAvYA;AAuYA;AAvYA;EAAA,0BAuYA;EAvYA;AAuYA;AAvYA;EAAA,sBAuYA;EAvYA;AAuYA;AAvYA;EAAA,qBAuYA;EAvYA;AAuYA;AAvYA;EAAA,qBAuYA;EAvYA;AAuYA;AAvYA;EAAA,gDAuYA;EAvYA;AAuYA;AAvYA;EAAA,iDAuYA;EAvYA;AAuYA;AAvYA;;EAAA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;AAAA;AAvYA;EAAA;AAuYA;AAvYA;;EAAA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;AAAA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,sBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,kBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,0EAuYA;EAvYA,8FAuYA;EAvYA;AAuYA;AAvYA;EAAA,sBAuYA;EAvYA,8BAuYA;EAvYA;AAuYA;AAvYA;EAAA,2GAuYA;EAvYA,yGAuYA;EAvYA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,qBAuYA;EAvYA,yBAuYA;EAvYA,2BAuYA;EAvYA,yBAuYA;EAvYA,0BAuYA;EAvYA,+BAuYA;EAvYA;AAuYA;AAvYA;EAAA,qBAuYA;EAvYA,yBAuYA;EAvYA,2BAuYA;EAvYA,yBAuYA;EAvYA,0BAuYA;EAvYA,+BAuYA;EAvYA;AAuYA;AAvYA;EAAA,qBAuYA;EAvYA,yBAuYA;EAvYA,2BAuYA;EAvYA,yBAuYA;EAvYA,0BAuYA;EAvYA,+BAuYA;EAvYA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA,yBAuYA;EAvYA,0BAuYA;EAvYA,wBAuYA;EAvYA,yBAuYA;EAvYA,8BAuYA;EAvYA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA,yBAuYA;EAvYA,0BAuYA;EAvYA,wBAuYA;EAvYA,yBAuYA;EAvYA,8BAuYA;EAvYA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA,yBAuYA;EAvYA,0BAuYA;EAvYA,wBAuYA;EAvYA,yBAuYA;EAvYA,8BAuYA;EAvYA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA,yBAuYA;EAvYA,0BAuYA;EAvYA,wBAuYA;EAvYA,yBAuYA;EAvYA,8BAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,0BAuYA;EAvYA;AAuYA;AAvYA;EAAA,0BAuYA;EAvYA;AAuYA;AAvYA;EAAA,0BAuYA;EAvYA;AAuYA;AAvYA;EAAA,0BAuYA;EAvYA,sBAuYA;EAvYA;AAuYA;AAvYA;EAAA,0BAuYA;EAvYA,qBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,mBAuYA;EAvYA;AAuYA;AAvYA;;EAAA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;;IAAA;MAAA;IAuYA;;IAvYA;MAAA;IAuYA;EAAA;;EAvYA;IAAA;EAuYA;;EAvYA;;IAAA;MAAA,aAuYA;MAvYA;IAuYA;;IAvYA;MAAA,UAuYA;MAvYA;IAuYA;EAAA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA,sCAuYA;IAvYA,wDAuYA;IAvYA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;AAAA;AAvYA;EAAA;AAuYA;AAvYA;;EAAA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA,kBAuYA;IAvYA,kBAuYA;IAvYA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA,uBAuYA;IAvYA,sDAuYA;IAvYA;EAuYA;;EAvYA;IAAA,uBAuYA;IAvYA,oDAuYA;IAvYA;EAuYA;;EAvYA;IAAA,uBAuYA;IAvYA,2DAuYA;IAvYA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA,oBAuYA;IAvYA;EAuYA;;EAvYA;IAAA,kBAuYA;IAvYA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA,iBAuYA;IAvYA;EAuYA;;EAvYA;IAAA,kBAuYA;IAvYA;EAuYA;;EAvYA;IAAA,eAuYA;IAvYA;EAuYA;;EAvYA;IAAA,kBAuYA;IAvYA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;AAAA;AAvYA;;EAAA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA,oBAuYA;IAvYA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA,oBAuYA;IAvYA;EAuYA;;EAvYA;IAAA,mBAuYA;IAvYA;EAuYA;AAAA;AAvYA;;EAAA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA,eAuYA;IAvYA,eAuYA;IAvYA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA,iBAuYA;IAvYA;EAuYA;;EAvYA;IAAA,mBAuYA;IAvYA;EAuYA;;EAvYA;IAAA,iBAuYA;IAvYA;EAuYA;;EAvYA;IAAA,iBAuYA;IAvYA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA,iBAuYA;IAvYA;EAuYA;;EAvYA;IAAA,mBAuYA;IAvYA;EAuYA;;EAvYA;IAAA,kBAuYA;IAvYA;EAuYA;;EAvYA;IAAA,eAuYA;IAvYA;EAuYA;;EAvYA;IAAA,kBAuYA;IAvYA;EAuYA;;EAvYA;IAAA,mBAuYA;IAvYA;EAuYA;AAAA;AAvYA;;EAAA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA;EAuYA;;EAvYA;IAAA,eAuYA;IAvYA;EAuYA;AAAA;AAvYA;;EAAA;IAAA;EAuYA;AAAA;AAvYA;EAAA,kBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,kDAuYA;EAvYA;AAuYA;AAvYA;EAAA,iDAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,iDAuYA;EAvYA;AAuYA;AAvYA;EAAA,kDAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,kDAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,qBAuYA;EAvYA;AAuYA;AAvYA;EAAA,gBAuYA;EAvYA,oBAuYA;EAvYA,4BAuYA;EAvYA;AAuYA;AAvYA;EAAA,sBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,WAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,kBAuYA;EAvYA;AAuYA;AAvYA;EAAA,mBAuYA;EAvYA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA,qBAuYA;EAvYA;AAuYA;AAvYA;EAAA,kBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,oBAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,WAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA;AAuYA;AAvYA;EAAA,uBAuYA;EAvYA,+DAuYA;EAvYA;AAuYA;AAvYA;EAAA;AAuYA","sourcesContent":["@import url(\"https://api.fontshare.com/v2/css?f[]=cabinet-grotesk@800,500,700,900&f[]=satoshi@400,500,700&f[]=zodiak@401&display=swap\");\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n:root {\n  --font-heading: \"Cabinet Grotesk\", ui-sans-serif, system-ui, sans-serif;\n  --font-body: \"Satoshi\", ui-sans-serif, system-ui, sans-serif;\n  /* Loaded at 401 only — italic 400. One cut, one job. */\n  --font-display: \"Zodiak\", ui-serif, Georgia, serif;\n  --brand: #002fa7;\n  --brand-hover: #00237e;\n  --accent-red: #e11d48;\n  /* Daybreak. Mirrors tailwind.config.js so plain CSS (gradients, rings) can\n     reach the same values without hard-coding them twice by eye. */\n  --night: #080b18;\n  --dawn-500: #ff8f5e;\n  --dawn-700: #d9531f;\n  /* One ring colour for the whole site. #d9531f is the only warm value that\n     clears 3:1 against BOTH the paper sections (3.8:1) and the night sections\n     (4.8:1) — a ring that is only visible on half the page is not a ring. */\n  --focus-ring: #d9531f;\n}\n\nbody {\n  margin: 0;\n  font-family: var(--font-body);\n  /* Kerning is not optional — Butterick, and every type designer since. Off by\n     default in some engines, which is why headline pairs like \"Yo\" and \"Ta\"\n     were sitting loose. */\n  font-kerning: normal;\n  font-feature-settings: \"kern\" 1, \"liga\" 1;\n  text-rendering: optimizeLegibility;\n  /* 120-145% of point size. Browser default is ~117%, which is too tight for\n     multi-line body copy at these sizes. */\n  line-height: 1.55;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: hsl(var(--background));\n  color: hsl(var(--foreground));\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-family: var(--font-heading);\n  letter-spacing: -0.02em;\n}\n\n::selection {\n  background: #002fa7;\n  color: #ffffff;\n}\n\n/* One visible focus style everywhere, replacing the per-component rings that\n   existed on some controls and not others. Keyboard-only (:focus-visible), so\n   it never fires on mouse clicks — the reason ad-hoc rings usually get removed. */\n:focus-visible {\n  outline: 2px solid hsl(var(--ring, 17 75% 49%));\n  outline-offset: 2px;\n  border-radius: 1px;\n}\n\n/* Motion is decoration here, never information: every animation on this site\n   has a static state that says the same thing. So reduce means remove, not\n   shorten. Belt-and-braces alongside the motion-safe: variants in the markup —\n   this also catches third-party CSS we do not control. */\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n  }\n}\n\n@layer base {\n  /* ── Semantic tokens ──────────────────────────────────────────────────\n     These are the shadcn variables the whole app already runs on, retuned\n     to the Daybreak palette. Extending this layer rather than adding a\n     second one means every Button, Card, Input and Dialog in the product\n     inherits the warmer ground for free, and there is still exactly one\n     place to change a colour.\n\n     The cool greys are gone. #f4f5f7 beside an indigo reads as a dashboard;\n     the same layout on warm paper reads as print, and the canvas being\n     slightly darker than the cards gives every card elevation for nothing —\n     white-on-white had none. */\n  :root {\n    --background: 40 47% 96%;      /* paper — the canvas */\n    --foreground: 24 10% 10%;      /* warm near-black */\n    --card: 0 0% 100%;             /* cards sit ABOVE the canvas, not level with it */\n    --card-foreground: 24 10% 10%;\n    --popover: 0 0% 100%;\n    --popover-foreground: 24 10% 10%;\n    --primary: 223 100% 33%;       /* Klein blue — the product's colour, unchanged */\n    --primary-foreground: 0 0% 100%;\n    --secondary: 40 30% 92%;\n    --secondary-foreground: 24 10% 12%;\n    --muted: 40 30% 92%;\n    --muted-foreground: 30 6% 34%;\n    --accent: 40 30% 92%;\n    --accent-foreground: 24 10% 12%;\n    --destructive: 346 84% 51%;\n    --destructive-foreground: 0 0% 98%;\n    --border: 38 31% 85%;          /* sand */\n    --input: 38 31% 85%;\n    --ring: 17 75% 49%;            /* dawn — the one focus colour, both grounds */\n    --chart-1: 223 100% 33%;\n    --chart-2: 160 84% 39%;\n    --chart-3: 22 100% 68%;        /* dawn, so charts and the page share a light */\n    --chart-4: 346 84% 51%;\n    --chart-5: 30 6% 40%;\n    --radius: 0.25rem;\n\n    /* ── Type scale ────────────────────────────────────────────────────\n       Fluid where it needs to be, fixed where fluid type would wobble.\n       Named by role, not by size, so a heading can be retuned once. */\n    --type-display: clamp(2.6rem, 7.2vw, 6rem);\n    --type-h1: clamp(2.25rem, 4.6vw, 3.5rem);\n    --type-h2: clamp(1.875rem, 3.2vw, 3rem);\n    --type-h3: 1.5rem;\n    --type-body-lg: 1.125rem;\n    --type-body: 1rem;\n    --type-small: 0.875rem;\n    --type-label: 0.75rem;\n    --tracking-display: -0.045em;\n    --tracking-heading: -0.02em;\n    --tracking-label: 0.2em;\n    --leading-display: 0.92;\n    --leading-body: 1.55;\n\n    /* ── Shape, rhythm, layering ───────────────────────────────────── */\n    --width-content: 80rem;\n    --width-prose: 42rem;\n    --shadow-card: 0 1px 2px rgba(28, 25, 23, 0.04);\n    --shadow-lift: 0 12px 32px -14px rgba(28, 25, 23, 0.22);\n    --shadow-stage: 0 44px 90px -44px rgba(0, 0, 0, 0.95);\n    --z-nav: 60;\n    --z-overlay: 80;\n  }\n\n  /* ── The night theme ───────────────────────────────────────────────\n     Put data-surface=\"night\" on any dark section and the shadcn components\n     inside it stop needing hand-written dark variants. This is why Stage\n     sets it: a <Button> or <Input> dropped onto the hero should already be\n     correct rather than needing a `dark ?` ternary at every call site.\n\n     The status colours lighten here rather than keeping their light-ground\n     values: #047857 green on an indigo ground is 2.4:1, which is how the\n     hero's verification highlights ended up as the least readable thing on\n     a page whose entire argument is verification.\n\n     The same block serves html.dark — the app's Night mode (see\n     lib/appearance.jsx and the appearance section at the end of this file). */\n  [data-surface=\"night\"],\n  .dark {\n    --background: 226 54% 6%;\n    --foreground: 0 0% 100%;\n    --card: 226 40% 10%;\n    --card-foreground: 0 0% 100%;\n    --popover: 226 40% 10%;\n    --popover-foreground: 0 0% 100%;\n    --secondary: 226 30% 16%;\n    --secondary-foreground: 0 0% 100%;\n    --muted: 226 30% 16%;\n    --muted-foreground: 226 12% 72%;\n    --accent: 22 100% 81%;         /* dawn-300 */\n    --accent-foreground: 226 54% 6%;\n    --border: 226 20% 26%;\n    --input: 226 20% 26%;\n    --ring: 22 100% 81%;\n    --destructive: 351 95% 71%;\n    --destructive-foreground: 226 54% 6%;\n  }\n}\n\n@layer base {\n  * {\n    @apply border-border;\n  }\n  body {\n    @apply bg-background text-foreground;\n  }\n}\n\n/* Subtle grid pattern for hero backgrounds */\n.grid-pattern {\n  background-image: linear-gradient(#e4e4e7 1px, transparent 1px),\n    linear-gradient(90deg, #e4e4e7 1px, transparent 1px);\n  background-size: 48px 48px;\n  background-position: -1px -1px;\n}\n\n.u-label {\n  font-size: var(--type-label);\n  letter-spacing: var(--tracking-label);\n  text-transform: uppercase;\n  font-weight: 700;\n  line-height: 1.4;\n}\n\n.font-heading { font-family: var(--font-heading); }\n.font-body { font-family: var(--font-body); }\n\n/* The emphasis word. Italic serif at display size next to a tight grotesk\n   needs two corrections to sit right: optical size runs large, so it is scaled\n   back slightly, and the italic's forward lean opens a gap on the left that has\n   to be closed by hand. Without these it reads as a font-loading accident. */\n.font-display {\n  font-family: var(--font-display);\n  font-style: italic;\n  font-weight: 400;\n  font-size: 0.94em;\n  letter-spacing: -0.005em;\n  margin-left: -0.02em;\n  padding-right: 0.06em;\n}\n\n/* Score ring animation */\n@keyframes ring-fill {\n  from { stroke-dashoffset: 283; }\n}\n.animate-ring { animation: ring-fill 1s ease-out; }\n\n/* Stagger fade for lists */\n@keyframes fade-up {\n  from { opacity: 0; transform: translateY(8px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n.fade-up { animation: fade-up 0.4s ease-out both; }\n\n/* Marquee shift for hero */\n/* .text-brand / .bg-brand / .border-brand / .hover:bg-brand-hover are now\n   generated by Tailwind from theme.extend.colors.brand (tailwind.config.js).\n   Hand-writing them here covered only those four exact classes and silently\n   dropped every other variant. */\n\n/* Sharp scrollbar */\n::-webkit-scrollbar { width: 10px; height: 10px; }\n::-webkit-scrollbar-thumb { background: #d4d4d8; }\n::-webkit-scrollbar-thumb:hover { background: #a1a1aa; }\n::-webkit-scrollbar-track { background: #fafafa; }\n\n\n/* Idle drift for the landing page's 3D stack. Deliberately slow and small:\n   the object should feel physical, not animated. motion-safe: in the markup\n   means prefers-reduced-motion switches it off entirely. */\n/* One pass of light across the index horizon when the search page settles.\n   Runs once, says nothing the band does not already say in numbers, and is\n   applied under motion-safe: so a reduced-motion visitor simply gets the\n   finished band. */\n@keyframes horizonsweep {\n  from { transform: translateX(-100%); }\n  to   { transform: translateX(100%); }\n}\n\n@keyframes truthdrift {\n  0%, 100% { transform: translateY(0) rotate(0deg); }\n  50%      { transform: translateY(-10px) rotate(-0.4deg); }\n}\n\n/* The landing page's one page-turn: a proximity snap out of the hero into\n   the video band, and nothing else. `proximity`, not `mandatory`, so a\n   reader stopped mid-hero is left alone; only the hero and the band carry\n   an align, so the rest of the page scrolls freely. The class lives on\n   <html> only while the landing page is mounted. */\nhtml.snap-hero { scroll-snap-type: y proximity; }\nhtml.snap-hero .snap-target { scroll-snap-align: start; }\n\n/* ══════════════════════════════════════════════════════════════════════════\n   Appearance (lib/appearance.jsx). Three attributes on <html>, present only\n   while an app page is mounted: `.dark`, `data-font`, `data-radius`.\n   Nothing here exists without them, so light mode is byte-identical.\n\n   Night is a remap of the literal Daybreak utilities rather than a second\n   set of tokens, because the app is written in `bg-white` / `border-sand` /\n   `text-stone-*` in a hundred files. This block is the ONE place night\n   lives: an outlier found on a page is fixed by adding it here, never at\n   the call site. Rules follow Daybreak — the white ramp for text on night,\n   never stone; dawn stays light and is never a status colour; the focus\n   ring is unchanged. Values and contrast notes: the design spec\n   (docs/superpowers/specs/2026-09-09-appearance-settings-design.md).\n   ══════════════════════════════════════════════════════════════════════════ */\n.dark { color-scheme: dark; }\n.dark .bg-paper        { background-color: #080b18; }   /* night       — the canvas  */\n.dark .bg-paper-deep   { background-color: #05070f; }   /* night-deep  — the sidebar */\n.dark .bg-white        { background-color: #0e1326; }   /* night-lift  — every card  */\n.dark .bg-night        { background-color: #182040; }   /* raised: active nav, chips */\n.dark .bg-night-lift   { background-color: #242c52; }\n.dark .bg-sand         { background-color: rgba(255, 255, 255, 0.18); }\n.dark .bg-stone-50,\n.dark .bg-stone-100    { background-color: rgba(255, 255, 255, 0.06); }\n.dark .border-sand,\n.dark .border-stone-200 { border-color: rgba(255, 255, 255, 0.14); }\n.dark .border-paper-deep { border-color: rgba(255, 255, 255, 0.08); }\n.dark .border-night    { border-color: rgba(255, 255, 255, 0.6); }   /* a selected card keeps its weight */\n.dark .text-stone-950,\n.dark .text-stone-900  { color: #ffffff; }\n.dark .text-stone-700  { color: rgba(255, 255, 255, 0.78); }\n.dark .text-stone-600  { color: rgba(255, 255, 255, 0.62); }\n.dark .text-paper-deep { color: rgba(255, 255, 255, 0.12); }        /* the ring track */\n.dark .hover\\:bg-sand:hover,\n.dark .hover\\:bg-sand\\/70:hover { background-color: rgba(255, 255, 255, 0.08); }\n.dark .hover\\:bg-paper:hover,\n.dark .hover\\:bg-paper-deep:hover,\n.dark .hover\\:bg-stone-50:hover { background-color: rgba(255, 255, 255, 0.06); }\n.dark .hover\\:text-stone-900:hover,\n.dark .hover\\:text-stone-950:hover { color: #ffffff; }\n.dark .bg-brand        { background-color: #2f5fe0; }   /* white on it 5.5:1, on night 3.5:1 */\n.dark .hover\\:bg-brand-hover:hover { background-color: #3f6ff0; }\n.dark .text-brand      { color: #7c9cff; }\n.dark .hover\\:text-brand:hover { color: #9db5ff; }\n.dark .shadow-\\[var\\(--shadow-card\\)\\] { box-shadow: none; }\n/* Status tints: the hue stays, the pastel goes. */\n.dark .bg-emerald-50   { background-color: rgba(16, 185, 129, 0.14); }\n.dark .text-emerald-700 { color: #6ee7b7; }\n.dark .border-emerald-200 { border-color: rgba(110, 231, 183, 0.35); }\n.dark .bg-amber-50     { background-color: rgba(245, 158, 11, 0.14); }\n.dark .text-amber-700  { color: #fcd34d; }\n.dark .border-amber-200 { border-color: rgba(252, 211, 77, 0.35); }\n.dark .bg-sky-50       { background-color: rgba(14, 165, 233, 0.14); }\n.dark .text-sky-700    { color: #7dd3fc; }\n.dark .border-sky-200  { border-color: rgba(125, 211, 252, 0.35); }\n.dark .bg-rose-50,\n.dark .bg-rose-50\\/50  { background-color: rgba(225, 29, 72, 0.10); }\n.dark .text-rose-700   { color: #fda4af; }\n.dark .border-rose-200,\n.dark .border-rose-300 { border-color: rgba(253, 164, 175, 0.35); }\n.dark .hover\\:bg-rose-100:hover { background-color: rgba(225, 29, 72, 0.2); }\n\n/* Alpha variants of the remapped surfaces. Tailwind emits these as\n   rgb(<paper> / .6) and so on, which reads as a grey slab on night. */\n.dark .bg-paper\\/50,\n.dark .bg-paper\\/60,\n.dark .bg-paper\\/85,\n.dark .bg-paper\\/95   { background-color: rgba(8, 11, 24, 0.85); }\n.dark .bg-paper-deep\\/95 { background-color: rgba(5, 7, 15, 0.95); }\n.dark .bg-white\\/60,\n.dark .bg-white\\/70,\n.dark .bg-white\\/90   { background-color: rgba(14, 19, 38, 0.92); }\n.dark .bg-sand\\/40,\n.dark .bg-sand\\/60,\n.dark .bg-sand\\/70    { background-color: rgba(255, 255, 255, 0.10); }\n.dark .border-sand\\/70 { border-color: rgba(255, 255, 255, 0.14); }\n/* The first-run tour offer: a dawn glow on night, not a tan block. */\n.dark .bg-dawn-100\\/70,\n.dark .hover\\:bg-dawn-100:hover { background-color: rgba(255, 143, 94, 0.16); }\n/* The active tab in every TabsList that lifts it to white. */\n.dark .data-\\[state\\=active\\]\\:bg-white[data-state=\"active\"] { background-color: #182040; }\n/* The remaining stone shades. */\n.dark .text-stone-800  { color: rgba(255, 255, 255, 0.9); }\n.dark .text-stone-500  { color: rgba(255, 255, 255, 0.55); }\n.dark .text-stone-400  { color: rgba(255, 255, 255, 0.45); }\n.dark .text-stone-300  { color: rgba(255, 255, 255, 0.35); }\n.dark .hover\\:text-stone-800:hover { color: rgba(255, 255, 255, 0.9); }\n.dark .border-stone-400,\n.dark .border-stone-400\\/70,\n.dark .hover\\:border-stone-400:hover { border-color: rgba(255, 255, 255, 0.3); }\n.dark .placeholder\\:text-stone-500::placeholder { color: rgba(255, 255, 255, 0.4); }\n/* Native form controls under color-scheme: dark get a grey UA background;\n   the app draws its own. :where() keeps this at utility specificity so any\n   explicit bg-* class, remapped or not, still wins. */\n.dark :where(input:not([type=\"checkbox\"]):not([type=\"radio\"]), textarea, select) { background-color: transparent; }\n\n/* Typeface. Three variables, already what every heading and body rule\n   reads. The Zodiak emphasis word falls back to ui-serif under every\n   alternative so the human word keeps a different voice. */\n[data-font=\"geometric\"] {\n  --font-heading: \"Outfit\", ui-sans-serif, system-ui, sans-serif;\n  --font-body: \"Outfit\", ui-sans-serif, system-ui, sans-serif;\n  --font-display: ui-serif, Georgia, serif;\n}\n[data-font=\"neutral\"] {\n  --font-heading: \"Inter\", ui-sans-serif, system-ui, sans-serif;\n  --font-body: \"Inter\", ui-sans-serif, system-ui, sans-serif;\n  --font-display: ui-serif, Georgia, serif;\n}\n[data-font=\"system\"] {\n  --font-heading: ui-sans-serif, system-ui, -apple-system, \"Segoe UI\", sans-serif;\n  --font-body: ui-sans-serif, system-ui, -apple-system, \"Segoe UI\", sans-serif;\n  --font-display: ui-serif, Georgia, serif;\n}\n\n/* Corners. Tailwind's sm/md/lg all derive from --radius (sm = radius − 4px),\n   so one variable moves every `rounded-sm` at once. `rounded-full` is\n   untouched. sharp is today's value and stays the default. */\n[data-radius=\"cut\"]   { --radius: 0.375rem; }\n[data-radius=\"soft\"]  { --radius: 0.625rem; }\n[data-radius=\"round\"] { --radius: 1rem; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
